module.exports = {
	"it": {
		"moet-core": {
			"select_language": {
				"title": "Seleziona lingua",
				"paragraph": "Questa sarà la lingua predefinita.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Sempre compresi",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Offri tutti i nostri metodi di pagamento."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Paga ora"
							},
							"description": {
								"default": "Offri pagamenti istantanei tramite bonifico bancario."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "Paga in 30 giorni"
							},
							"description": {
								"default": "Offri 30 giorni per pagare. Zero interessi."
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Finanziamento"
							},
							"description": {
								"default": "Offri di pagare in 6‑36 mesi.",
								"DE": "Offri di pagare in 6‑24 mesi",
								"AT": "Offri di pagare in 6‑24 mesi."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Paga in 3 rate"
							},
							"description": {
								"default": "Offri 3 rate senza interessi.",
								"GB": "Offri 3 rate senza interessi."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Dilaziona in 4",
								"US": "Paga in 3 rate",
								"AU": "Paga in 4 rate"
							},
							"description": {
								"default": "Offri 4 rate senza interessi.",
								"GB": "Offri 4 rate senza interessi."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Metodi di pagamento"
					},
					"description": {
						"default": "Scegli tra le nostre soluzioni di pagamento autonome. Scegline una o combinane svariate. Semplice, integrazione una tantum, non importa quale sia la tua scelta."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Paga ora"
							},
							"description": {
								"default": "Offri pagamenti istantanei tramite bonifico bancario."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "Paga in 30 giorni"
							},
							"description": {
								"default": "Offri 30 giorni per pagare. Zero interessi."
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Finanziamento"
							},
							"description": {
								"default": "Offri di pagare in 6‑36 mesi.",
								"DE": "Offri di pagare in 6‑24 mesi.",
								"AT": "Offri di pagare in 6‑24 mesi."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Paga in 3 rate"
							},
							"description": {
								"default": "Offri 3 rate senza interessi.",
								"GB": "Offri 3 rate senza interessi."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Dilaziona in 4",
								"US": "4 pagamenti",
								"CA": "4 pagamenti",
								"AU": "Paga in 4 rate"
							},
							"description": {
								"default": "Offri 4 rate senza interessi.",
								"GB": "Offri 4 rate senza interessi.",
								"US": "Gli ordini da 35 a 1.000 USD possono essere dilazionati in 4 rate senza interessi, con scadenza bisettimanale.",
								"CA": "Gli ordini da 35 a 1.000 USD possono essere dilazionati in 4 rate senza interessi, con scadenza bisettimanale."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Sostituisci il checkout del tuo negozio con i servizi checkout completi di Klarna."
					},
					"description_expanded": {
						"default": "Sostituisci il checkout del tuo negozio con i servizi checkout completi di Klarna."
					}
				},
				"kp_one": {
					"name": {
						"default": "Metodo di pagamento"
					},
					"description": {
						"default": "Aggiungi i metodi di pagamento Klarna al tuo checkout"
					},
					"description_expanded": {
						"default": "L’offerta dei metodi di pagamento Klarna determina un aumento medio del tasso conversione pari al 30%, del 41% dell’AOV e del 36% della frequenza di acquisto."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Il campo è obbligatorio per procedere",
					"generic": "Il valore fornito non è valido",
					"required_suffix": "è obbligatorio per procedere",
					"generic_suffix": "non è valido",
					"min_one": "Devi selezionare almeno un elemento",
					"min": "Devi selezionare almeno {min} elementi",
					"max": "Non puoi selezionare più di {max} elementi",
					"given_name": "Nome mancante",
					"family_name": {
						"general": "Cognome mancante",
						"too_short": "Fornisci un cognome valido"
					},
					"date_of_birth": {
						"general": {
							"default": "Fornisci una data di nascita valida (GG/MM/AAAA)",
							"US": "Fornisci una data di nascita valida (GG/MM/AAAA)"
						},
						"too_young": "Tutte le parti interessate devono avere più di 16 anni",
						"too_young_eighteen": "Devi avere più di 18 anni"
					},
					"street_address": "Fornisci una via",
					"street_address2": "Fornisci un indirizzo valido alla linea 2",
					"postal_code": "Fornisci un codice postale",
					"country": "Fornisci un Paese",
					"region": "Fornisci una regione",
					"state": "Fornisci uno stato",
					"iban": "Fornisci un numero di conto (IBAN)",
					"companyName": "Fornisci una ragione sociale",
					"email": "Fornisci un indirizzo email valido",
					"contact_email": "Fornisci un indirizzo email valido",
					"support_email": "Fornisci un indirizzo email valido per l’assistenza clienti",
					"support_phone": "Fornisci un numero per l'assistenza valido",
					"selling_countries": "Devi selezionare almeno un Paese",
					"store_category": "Devi selezionare una delle opzioni",
					"name": "Fornisci un nome di negozio online valido",
					"legal_form": "Si prega di scegliere uno dei tipi di attività elencati",
					"generic_toggle_undefined": "Seleziona una delle opzioni",
					"website": "Fornisci un URL corretto",
					"bankAccounts": "Fornisci almeno un conto bancario",
					"product": "Seleziona un prodotto",
					"platform": "Seleziona una piattaforma",
					"password": "Crea una password sicura",
					"currency_code": "Fornisci un codice valuta",
					"account_holder": "Fornisci un intestatario di conto bancario",
					"account_type": "Fornisci un tipo di conto bancario",
					"routing_number": "Fornisci coordinate bancarie valide",
					"account_number": {
						"first": "Fornisci un numero di conto valido per il conto bancario predefinito",
						"second": "Fornisci un numero di conto valido per il primo conto bancario aggiuntivo",
						"third": "Fornisci un numero di conto valido per il secondo conto bancario aggiuntivo",
						"fourth": "Fornisci un numero di conto valido per il terzo conto bancario aggiuntivo",
						"general": "Fornisci un numero di conto bancario valido"
					},
					"role": "Fornisci un ruolo",
					"address": "Fornisci un indirizzo",
					"political_exposed_person": "Fornisci le informazioni PPE (Persona politicamente esposta)",
					"pep_position": "Fornisci le informazioni sulla posizione",
					"pep_relationship": "Fornisci le informazioni sulla relazione con la persona politicamente esposta",
					"goodsCategory": "Fornisci una categoria di beni",
					"registered": "Fornisci le informazioni riguardanti la registrazione della tua attività",
					"subjectToVat": "Fornisci un numero di Partiva IVA",
					"registrationCourt": "Fornisci un tribunale di registrazione",
					"registrationId": {
						"general": {
							"default": "Inserisci un codice fiscale aziendale valido",
							"AT": "Inserisci un codice fiscale aziendale valido",
							"AU": "Inserisci un ACN valido",
							"ES": "Inserisci un NIF/NIE/DNI aziendale valido",
							"GB": "Inserisci un numero di organizzazione valido",
							"GR": "Inserisci un numero G.E.MI. valido (Γ.Ε.ΜΗ.)",
							"CA": "Inserisci un numero di attività valido",
							"NZ": "Inserisci un numero di attività valido",
							"US": "Inserisci un numero di identificazione del datore di lavoro valido"
						},
						"missing_leading_0_GB": "Fornisci un numero di organizzazione di 8 cifre. Al tuo numero di organizzazione potrebbe mancare uno 0 iniziale (per es. 03452678)",
						"invalid": {
							"default": "Inserisci un codice fiscale aziendale valido",
							"AT": "Il codice fiscale aziendale deve contenere dai 5 agli 11 caratteri. Da notare che questo non è la partita IVA né il Merchant ID.",
							"AU": "L’ACN deve contenere 9 numeri, gli spazi non sono consentiti. Per es.: 123456789",
							"BE": "Il codice fiscale aziendale deve essere di 10 cifre. Per es.: 1234567890",
							"CA": "Il numero dell’azienda deve essere composto da 9 cifre. Per es.: 123456789",
							"CZ": "Il codice fiscale aziendale deve essere di 8 cifre. Per es.: 12345678",
							"DE": "Il codice fiscale aziendale deve contenere dai 6 agli 11 caratteri e deve cominciare con HRA, HRB, GnR, VR o PR seguito da uno spazio. Da notare che questo non è la partita IVA né il Merchant ID.",
							"ES": "I NIF/NIE/DNI devono essere composti da 8 o 9 caratteri e iniziare con una lettera/cifra seguita da 6 o 7 cifre e una lettera/cifra",
							"FI": "Il codice fiscale aziendale deve essere di 8 cifre con un trattino prima dell’ultima cifra, gli spazi non sono consentiti. Per es.: 1234567-8",
							"FR": "Il codice fiscale aziendale deve contenere 9 cifre, per es. 123 456 789 o 123456789 (SIREN), o 14 cifre, per es. 123 456 789 12345 oppure 12345678912345 (SIRET).",
							"IE": "Il numero di registrazione deve essere composto da 2 lettere seguite da 6 cifre o solo da 6 cifre se si tratta di una ditta individuale (ad esempio AB123456).",
							"IT": "Il codice fiscale aziendale deve essere di 11 cifre (per es.: 01234567890) o una combinazione di 16 caratteri alfanumerici maiuscoli (per es.: ABCABC12A12A123A)",
							"GB": "Il numero di organizzazione deve essere di 8 cifre. Per es.: 12345678, o due lettere seguite da 6 cifre (SC123456), o una lettera seguita da 7 cifre (S1234567)",
							"GR": "Il numero G.E.MI. deve contenere 12 cifre, ad esempio 012345678901",
							"NL": "Il codice fiscale aziendale deve essere di 8 cifre. Per es.: 12345678",
							"NO": "Il codice fiscale aziendale deve essere di 9 cifre, gli spazi non sono consentiti. Per es.: 123456789",
							"NZ": "Il numero dell’azienda deve essere composto da 9 cifre. Per es.: 1234567890123",
							"PL": "Il codice fiscale aziendale deve essere di 10 cifre, gli spazi non sono consentiti. Per es.: 1234561234",
							"PT": "Il numero di registrazione deve essere di 9 cifre, gli spazi non sono consentiti. Per es.: 123123123",
							"SE": "Il codice fiscale aziendale deve essere di 10 cifre con un trattino, gli spazi non sono consentiti. Per es.: 123456-1234",
							"US": "Il numero di identificazione del datore di lavoro deve essere di 9 cifre con un “-” dopo le prime due. Es: 12-3456789",
							"MX": "L’RFC deve contenere 12 caratteri, iniziare con iniziali della società, la data di costituzione a 6 cifre e il valore di controllo. Es.: ABC921010H20"
						}
					},
					"tocLink": "Si è verificato un errore con i Termini e condizioni. Riprova più tardi o contatta il nostro Servizio clienti scrivendo a {supportEmail}",
					"vat": {
						"general": {
							"default": "Inserisci un numero di partita IVA valido",
							"AU": "Inserisci un ABN valido",
							"ES": "Inserisci un NIF/NIE/DNI aziendale valido",
							"NZ": "Inserisci un numero GST valido"
						},
						"invalid": {
							"default": "Numero di partita IVA non valido",
							"AT": "Il numero di partita IVA (UID) deve essere ATU seguito da 8 cifre. Per es.: ATU12345678",
							"AU": "L’ABN deve essere di 11 cifre.",
							"CZ": "Il numero di partita IVA deve essere CZ seguito da 8, 9 o 10 cifre. Per es.: CZ123456789",
							"GR": "Il numero VAT deve essere di 9 cifre e deve iniziare con EL. Per es.: EL123456789",
							"DE": "Il numero di partita IVA (USt-IdNr.) deve essere DE seguito da 9 cifre. Per es.: DE123456789",
							"ES": "I NIF/NIE/DNI devono essere composti da 8 o 9 caratteri e iniziare con una lettera/cifra seguita da 6 o 7 cifre e una lettera/cifra",
							"FR": "Il numero di partita IVA deve essere FR seguito da 2 lettere/numeri e 9 numeri (SIREN), per es.: FRXX123456789",
							"GB": "Il numero di partita IVA deve contenere dai 6 ai 15 caratteri.",
							"IE": "La partita IVA deve essere IE seguito da 8 o 9 caratteri che includono 1 o 2 lettere. Per es.: IE1234567WA, IE1234567A",
							"IT": "Il numero di partita IVA deve essere IT seguito da 11 cifre. Per es.: IT12345678912",
							"NL": "Il numero di partita IVA (BTW-id) deve essere NL seguito da 9 cifre, seguito da B e 2 cifre. Per es.: NL123456789B12",
							"NZ": "Il numero GST deve essere composto da 8 cifre (12345678) o  9 cifre (123456789), con o senza trattini ogni 3 cifre(123-123-123 oppure 123123123)",
							"PL": "Il numero di partita IVA (NIP) deve essere PL seguito da 10 cifre. Per es.: PL1234567890",
							"PT": "Il numero di partita IVA deve essere PT seguito da 9 cifre. Per es.: PT123123123",
							"MX": "L’RFC deve iniziare con le iniziali della società, la data di costituzione di 6 cifre e il valore di controllo. Es.: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Fornisci le ultime 4 cifre del numero di previdenza sociale",
							"format": "Inserisci le ultime 4 cifre del numero di previdenza sociale"
						},
						"US_FULL_SSN": {
							"general": "Fornisci l’intero numero di previdenza sociale (9 cifre)",
							"format": "Fornisci il tuo numero completo di previdenza sociale (9 cifre)"
						},
						"CA": {
							"general": "Fornisci un numero valido di previdenza sociale o di passaporto",
							"format": "Previdenza sociale: XXX-XXX-XXX / Numero passaporto: ABXXXXXX"
						},
						"SE": {
							"general": "Inserisci un numero valido d’identificazione personale (PNO)",
							"format": "Inserisci il PNO nel formato: AAAAMMGG-XXXX"
						},
						"FI": {
							"general": "Inserisci un codice valido di identificazione personale (HETU)",
							"format": "Inserisci l’HETU nel formato: GGMMAASXXXX"
						},
						"NO": {
							"general": "Fornisci un numero valido d’identificazione nazionale",
							"format": "Inseriscilo nel formato: GGMMAAXXXXX"
						},
						"DK": {
							"general": "Inserisci un numero valido d’identificazione personale (CPR)",
							"format": "Inserisci il CPR nel formato: GGMMAA-XXXX"
						},
						"IT": {
							"general": "Per favore inserisci un codice fiscale valido",
							"format": "Per favore inserisci il codice fiscale nel seguente formato: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Inserisci un numero identificativo personale (DNI o NIE)",
							"format": "Inserisci il DNI o NIE, per es. 12345678A"
						},
						"PL": {
							"general": "Inserisci un codice valido di identificazione personale (PESEL)",
							"format": "Inseriscilo nel formato: YYMMDDZZZXQ"
						},
						"default": {
							"general": "Fornisci un numero di passaporto valido"
						}
					},
					"store_name": "Fornisci un nome di negozio online valido"
				},
				"errors_keys": {
					"correlationIdLabel": "ID di correlazione: {correlationId}",
					"decisionTaken": "Decisione di pre-valutazione già presa. Aggiorna la pagina.",
					"maintenanceMode": "Al momento la nostra app è fuori servizio per manutenzione. Ti preghiamo di riprovare più tardi",
					"validation": {
						"storeName": {
							"invalidType": "Fornisci un nome di negozio valido."
						},
						"email": {
							"invalidType": "Fornisci un indirizzo email valido."
						},
						"goodsCategory": {
							"invalidType": "Fornisci una categoria di beni."
						},
						"website": {
							"invalidType": "Fornisci un sito corretto."
						}
					}
				}
			},
			"general": {
				"yes": "Sì",
				"no": "No",
				"encrypted_text": "*******",
				"pricing_link_eu": "Vedi tutti i prezzi per Paese",
				"pricing_link_us": "Vedi prezzi",
				"formFieldOptional": "opzionale",
				"buttons": {
					"next": "Avanti",
					"back": "Indietro",
					"continue": "Continua",
					"submit_application": {
						"default": "Inzia",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Inizia"
					},
					"add_aditional_item": "+ Aggiungi elemento addizionale"
				},
				"unknown_step_title": "Fornire le informazioni richieste",
				"selected": "Selezionati",
				"clear_all": "Elimina tutti"
			},
			"errors": {
				"general": "Si è verificato un errore. Contatta il nostro supporto.",
				"salesforce": "Prova ad aggiornare la pagina. Se questo errore persiste, invia l’ID dell’errore al canale Slack #smoothforce-support e ti aiuteremo.",
				"managed_kyc": "Prova ad aggiornare la pagina. Se questo errore persiste, contatta il nostro Supporto Merchant o il tuo contatto di vendita.",
				"copy": "Copia",
				"noTermsAccepted": "Leggi e accetta tutti i nostri accordi elencati",
				"termsAlreadyAccepted": "Hai già accettato tutti gli accordi elencati",
				"mandatoryField": " è richiesto"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Impresa individuale",
					"PARTNERSHIP": "Partnership",
					"PUBLIC_LISTED_COMPANY": "Società quotata in borsa",
					"PRIVATE_COMPANY": "Società privata"
				},
				"organization_entity_types": {
					"C_CORP": "C corporation",
					"S_CORP": "S corporation",
					"PARTNERSHIP": "Partnership",
					"TRUST_ESTATE": "Fondo fiduciario/immobiliare",
					"INDIVIDUAL": "Individuo",
					"SOLE_PROPRIETORSHIP": "Azienda individuale",
					"SOLE_TRADER": "Impresa individuale",
					"LIMITED_LIABILITY_COMPANY": "Società a responsabilità limitata",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "LLC a socio unico"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento da adulti",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Prodotti automobilistici - Parti e accessori per autoveicoli",
					"BAGS_AND_WALLETS": "Gioielli e accessori - Borse e portafogli",
					"BODY_AND_HAIR_CARE": "Salute e bellezza - Cura del corpo e dei capelli",
					"BOOK_AND_MAGAZINES": "Tempo libero - Libri e riviste",
					"CANDY": "Cibo e bevande - Dolciumi",
					"CAR_ELECTRONICS": "Elettronica - Elettronica per auto",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Articoli per bambini - Abbigliamento da bambini e prodotti per la nutrizione",
					"CHILDREN_TOYS": "Articoli per bambini - Giocattoli per bambini",
					"CLEANING_AND_SANITARY": "Casa e giardino - Pulizia e igiene",
					"COLLECTIBLES": "Tempo libero, sport e hobby - Collezionismo",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Tempo libero, sport e hobby - Negozi concept e articoli vari",
					"COSMETICS": "Salute e bellezza - Cosmetici",
					"COSTUMES_AND_PARTY_SUPPLIES": "Tempo libero, sport e hobby - Costumi e materiale per feste",
					"DATING_SERVICES": "Prodotti immateriali - Servizi di incontri",
					"DECORATION_AND_ART": "Casa e giardino - Decorazione e arte",
					"DIETARY_SUPPLEMENTS": "Salute e bellezza - Integratori alimentari",
					"DIGITAL_SERVICES": "Prodotti immateriali - Servizi digitali",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Articoli per bambini - Articoli vari per bambini",
					"DIVERSIFIED_ELECTRONICS": "Elettronica - Articoli elettronici vari",
					"DIVERSIFIED_ENTERTAINMENT": "Tempo libero - Intrattenimento diversificato",
					"DIVERSIFIED_EROTIC_MATERIAL": "Materiale erotico - Materiale erotico vario",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Salute e bellezza - Articoli vari per salute e bellezza",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Casa e giardino - Articoli vari per casa e giardino",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Gioielli e accessori - Gioielli e accessori vari",
					"EDUCATION": "Prodotti immateriali - Educazione",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elettronica - Apparecchiature elettroniche e relativi accessori",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiale erotico - Abbigliamento erotico e accessori",
					"EVENT_TICKETS": "Prodotti immateriali - Biglietti di eventi",
					"FOOD_AND_BEVERAGE": "Cibo e bevande - Cibo e bevande",
					"FRAGRANCES": "Salute e bellezza - Fragranze",
					"FURNITURE": "Casa e giardino - Mobili",
					"GENERAL_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento generico",
					"HOBBY_ARTICLES": "Tempo libero, sport e hobby - Articoli per hobby",
					"HOUSEHOLD_ELECTRONICS": "Elettronica - Elettronica per la casa",
					"JEWELRY_AND_WATCHES": "Gioielli e accessori - Gioielli e orologi",
					"KITCHENWARE": "Casa e giardino - Articoli da cucina",
					"MARKETPLACES": "Prodotti immateriali - Piattaforme di mercato",
					"MUSIC_AND_MOVIES": "Tempo libero - Musica e film",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Tempo libero, sport e hobby - Strumenti e attrezzature musicali",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Gioielli e accessori - Occhiali da sole e lenti non da vista",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elettronica - Prodotti per ufficio e relativi accessori",
					"OTHER_SERVICES": "Prodotti immateriali - Altri servizi",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Salute e bellezza - Cura personale e miglioramento del corpo",
					"PET_SUPPLIES": "Casa e giardino - Articoli per animali domestici",
					"PHARMACEUTICAL_PRODUCTS": "Salute e bellezza - Prodotti farmaceutici",
					"PLANTS_AND_FLOWERS": "Casa e giardino - Piante e fiori",
					"PRESCRIPTION_OPTICS": "Salute e bellezza - Ottica da prescrizione",
					"PRINTS_AND_PHOTOS": "Tempo libero, sport e hobby - Stampe e foto",
					"SAFETY_PRODUCTS": "Casa e giardino - Prodotti per la sicurezza",
					"SEX_TOYS": "Materiale erotico - Sex toys",
					"SPORTS_GEAR_AND_OUTDOOR": "Tempo libero, sport e hobby - Abbigliamento sportivo e outdoor",
					"TOBACCO": "Cibo e bevande - Tabacco",
					"TOOLS_AND_HOME_IMPROVEMENT": "Casa e giardino - Attrezzi e migliorie per la casa",
					"TRAVEL_SERVICES": "Prodotti immateriali - Servizi per i viaggi",
					"UNDERWEAR": "Abbigliamento e calzature - Intimo",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Tempo libero - Videogiochi e relativi accessori",
					"WHEELS_AND_TIRES": "Prodotti automobilistici - Ruote e pneumatici",
					"WINE_BEER_AND_LIQUOR": "Cibo e bevande - Vino, birra e liquori",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento giovanile",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Limitazione di età - Giochi d’azzardo, scommesse, casinò e lotterie",
					"CHARITIES_AND_NGO": "Prodotti immateriali - Servizi di beneficenza e ONG",
					"EROTIC_SERVICES": "Materiale erotico - Servizi erotici",
					"FINANCIAL_SERVICES_CRYPTO": "Servizi finanziari - Attività relative alle criptovalute",
					"FINANCIAL_SERVICES_MSB": "Servizi finanziari - Attività di servizio per il denaro",
					"FINANCIAL_SERVICES_E_WALLETS": "Servizi finanziari - Portafogli elettronici",
					"FINANCIAL_SERVICES_TRADING": "Servizi finanziari - Trading",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Prodotti immateriali - Comunità su piattaforme social",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Viaggi - Viaggi aerei e compagnie di navigazione",
					"TRAVEL_BROKER_AND_AGENCIES": "Viaggi - Broker e agenzie",
					"TRAVEL_GROUND_TRANSPORTATION": "Viaggi - Trasporto via terra",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Viaggi - Hotel e resort",
					"EVENT_ORGANIZER": "Eventi - Organizzatori",
					"EVENT_BROKER_AND_AGENCIES": "Eventi - Intermediari e agenzie"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "California",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "Distretto di Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawaii",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "Nuovo Mexico",
					"NY": "New York",
					"NC": "Carolina del Nord",
					"ND": "Dakota del Nord",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "Carolina del sud",
					"SD": "Dakota del sud",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "Virginia Occidentale",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Persona",
						"COMPANY": "Azienda"
					},
					"roles": {
						"OWNER": "Titolare",
						"ULTIMATE_BENEFICIAL_OWNER": "Beneficiario assoluto",
						"CONTROL_OVER_MANAGEMENT": "Controllo sulla gestione",
						"APPLICANT": "Firmatario autorizzato",
						"SOLE_TRADER": "Impresa individuale",
						"PARTNER": "Partner"
					}
				},
				"payment_intervals": {
					"DAILY": "Quotidianamente",
					"WEEKLY": "Settimanalmente"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Vendita tradizionale di beni",
						"description": "Il commerciante sta vendendo prodotti o servizi in modo tradizionale: i beni sono considerati completamente consumati al momento della prima consegna e tipicamente non c’è un periodo esteso tra l’ordine e la consegna"
					},
					"VOUCHER": {
						"label": "Buoni",
						"description": "Più del 10% delle vendite consiste in buoni e/o carte regalo"
					},
					"MEMBERSHIP": {
						"label": "Adesioni",
						"description": "Più del 10% delle vendite consiste in adesioni"
					},
					"SUBSCRIPTION": {
						"label": "Iscrizione",
						"description": "Più del 10% delle vendite consiste in iscrizioni"
					},
					"PHARMACIES": {
						"label": "Farmacie",
						"description": "Il commerciante vende farmaci con o senza prescrizione"
					},
					"US_PHARMACIES": {
						"label": "Farmacie statunitensi",
						"description": "Il commerciante vende farmaci con o senza prescrizione negli Stati Uniti"
					},
					"MEDICAL_SERVICES": {
						"label": "Servizi medici",
						"description": "Il commerciante vende servizi medici quali test, esami, assistenza infermieristica"
					},
					"MARKETPLACES": {
						"label": "Piattaforme di mercato",
						"description": "Il commerciante ha una relazione subcommerciale"
					},
					"FIREARM_DEALERS": {
						"label": "Rivenditori di armi da fuoco",
						"description": "Il commerciante vende armi e munizioni che richiedono una licenza"
					},
					"AUCTIONS": {
						"label": "Aste",
						"description": "Il commerciante è una casa d’aste"
					},
					"ALCOHOL": {
						"label": "Alcool",
						"description": "Il commerciante vende alcool"
					},
					"TOBACCO": {
						"label": "Tabacco",
						"description": "Il commerciante vende tabacco inclusa o esclusa nicotina o il commerciante vende sigarette elettroniche"
					},
					"HEMP_CBD_THC": {
						"label": "Canapa, CBD o THC",
						"description": "Il commerciante vende prodotti che contengono canapa, CBD o THC"
					},
					"DONATIONS_CHARITY": {
						"label": "Donazioni e beneficenza",
						"description": "Il commerciante è una organizzazione di donazioni o di beneficenza che si integra con “Pagamenti di liquidazione successivi”"
					},
					"TRAVEL": {
						"label": "Viaggi",
						"description": "Più del 10% delle vendite consiste in viaggi"
					},
					"EVENTS": {
						"label": "Eventi",
						"description": "Più del 10% delle vendite consiste in eventi"
					},
					"COURSES": {
						"label": "Corsi",
						"description": "Più del 10% delle vendite consiste in corsi"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Corsi di formazione",
						"description": "Il commerciante vende corsi di formazione che durano per un periodo di tempo specifico."
					},
					"FOOD_DELIVERY": {
						"label": "Consegna di cibo",
						"description": "Il commerciante fornisce un servizio di consegna di generi alimentari."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Pre-ordini personalizzati/mobili",
						"description": "Il commerciante vende prodotti in pre-ordine, come i mobili."
					},
					"DIGITAL_CONTENT": {
						"label": "Contenuti digitali",
						"description": "Il commerciante vende contenuti digitali, come e-book e giochi online."
					},
					"GAMING_INDUSTRY": {
						"label": "Industria del gioco d’azzardo (scommesse, casinò, lotterie)",
						"description": "Il commerciante fornisce servizi legati all’industria del gioco d’azzardo, come scommesse, casinò e le lotterie."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Buongiorno {firstName},",
						"primary_title_without_name": "Buongiorno,",
						"sub_title": "Essere o non essere Klarna, diceva Shakespeare.",
						"sub_title_no_products": "Inizia la tua esperienza Klarna selezionando un prodotto qui sotto",
						"sub_title_kp_products": "Seleziona un altro prodotto Klarna",
						"sub_title_ongoing_product": "Continua l’installazione di {productName}"
					},
					"sidebar_left": {
						"products": {
							"title": "Prodotti di pagamento",
							"text_blocks": [
								{
									"text": "Aggiungi una soluzione alla tua installazione"
								}
							]
						}
					},
					"buttons": {
						"start": "Inizia",
						"continue": "Continua",
						"view_summary": "Vedi riepilogo",
						"add_another_product": "Aggiungi un altro prodotto"
					},
					"goodie_bags": {
						"playground": {
							"title": "Area di test",
							"text": "Attiva l’area di test per esplorare e generare le credenziali di Test API in modo da poter testare la tua piattaforma.",
							"link": "Area di test"
						},
						"marketing_assets": {
							"title": "Risorse di marketing",
							"text": "Utilizzare Klarna significa un’esperienza smoooth per i tuoi clienti. Utilizza le nostre risorse di marketing per entusiasmarli.",
							"link": "Ottieni le risorse"
						},
						"your_application": {
							"title": "La tua richiesta",
							"text": "Clicca qui per completare la tua installazione o per visualizzare i dati della tua richiesta, compresi i Termini e le condizioni.",
							"link": "Apri"
						},
						"invite_more_users": {
							"title": "Invita più utenti",
							"text": "Invita i tuoi collaboratori al Portale Merchant, sarete in grado di impostare autorizzazioni personalizzate per ciascuno di loro!",
							"link": "Invita utenti"
						}
					},
					"footer": {
						"title": "Sempre compreso con Klarna",
						"list": {
							"merchant_portal": {
								"title": "Il Portale Merchant",
								"text_blocks": [
									{
										"text": "Gestisci tutto ciò che è Klarna con pieno accesso al backend."
									}
								]
							},
							"global_products": {
								"title": "Prodotti globali, visi locali",
								"text_blocks": [
									{
										"text": "Tutti i nostri prodotti sono realizzati per soddisfare le preferenze e le leggi locali."
									}
								]
							},
							"local_support": {
								"title": "Supporto locale per te e i tuoi clienti",
								"text_blocks": [
									{
										"text": "Abbiamo migliaia di persone pronte ad aiutare i tuoi clienti quando hanno bisogno di contatto umano."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna come strumento di marketing",
								"text_blocks": [
									{
										"text": "Ti daremo accesso a materiali Klarna che potrai usare nelle tue iniziative di marketing."
									}
								]
							},
							"single_integration": {
								"title": "Integrazione singola, aggiornamenti automatici",
								"text_blocks": [
									{
										"text": "Una integrazione, nessun aggiornamento. Mai."
									},
									{
										"text": "Una volta che hai integrato Klarna, hai fatto tutto. È sempre aggiornata, non hai bisogno di muovere un dito."
									}
								]
							},
							"no_risk": {
								"title": "Nessun rischio per te o per i tuoi clienti",
								"text_blocks": [
									{
										"text": "I tuoi pagamenti sono sempre garantiti, e i tuoi clienti sono tutelati dalla Protezione Acquirente Klarna."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Credenziali API Klarna",
							"text_blocks": [
								{
									"text": "Le credenziali API Klarna collegano il nostro prodotto al tuo negozio così puoi iniziare a vendere."
								}
							]
						},
						"toc_key": {
							"title": "Termini e condizioni",
							"text_blocks": [
								{
									"text": "Devi aggiornare i Termini e Condizioni del tuo e-commerce"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Istruzioni sull’integrazione",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "Come usare le credenziali API Klarna",
							"ordered_list": {
								"one": "Genera e scarica le tue credenziali",
								"two": "Incolla le credenziali (nome utente e password delle API Klarna) nella tua piattaforma come spiegato qui sotto nelle istruzioni dell’integrazione"
							}
						},
						"number_of_live_keys_in_total": {
							"title": "In totale 5 credenziali API Klarna",
							"text": "Puoi generare fino a cinque credenziali API Klarna. Ottieni la prima qui, poi crea le successive in Impostazioni.",
							"button": "Genera credenziali API Klarna"
						},
						"how_to_update_toc": {
							"title": "Come aggiornare i Termini e Condizioni",
							"ordered_list": {
								"one": "Visita il link",
								"two": "Leggi le istruzioni e copia il testo",
								"three": "Includilo nei Termini e Condizioni del tuo negozio online"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Ricordati di aggiornare il testo con i prodotti che hai stipulato.",
							"linkText": "Vai ai Termini e Condizioni >"
						},
						"buttons": {
							"back": "Indietro"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "La tua richiesta è in corso di valutazione…",
						"TRANSACTION_DETAILS_STARTED": "La tua richiesta è in corso di valutazione da parte del nostro team. Ti contatteremo il prima possibile.",
						"TRANSACTIONS_REVIEW_MANUAL": "La tua richiesta è in corso di valutazione da parte del nostro team. Ti contatteremo il prima possibile.",
						"TRANSACTIONS_ENABLED": "Congratulazioni! Ora puoi vendere con Klarna.",
						"PAYOUTS_REVIEW_AUTOMATED": "La tua richiesta di pagamento è in corso di valutazione…",
						"PAYOUTS_REVIEW_MANUAL": "La tua richiesta di pagamento è in corso di valutazione da parte del nostro team. Ti contatteremo il prima possibile.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "In attesa della tua prima vendita con Klarna…",
						"TRANSACTIONS_DISABLED": "Il tuo account è stato disabilitato finché non completi il passo abilita pagamenti.",
						"SUSPENDED": "Il tuo account è sospeso.",
						"notice": "Attualmente abbiamo tempi di attesa per valutare la tua richiesta più lunghi del solito. Non ti preoccupare, la tua richiesta è in corso di valutazione e ti contatteremo con maggiori informazioni sui passi successivi. Apprezziamo la tua pazienza e ti ringraziamo per la comprensione."
					},
					"statuses": {
						"pending": "In corso di valutazione",
						"done": "Fatto"
					},
					"in_review": {
						"title": "Stiamo valutando la tua richiesta.",
						"subtitle": "Stiamo attualmente effettuando una valutazione finale della tua richiesta con Klarna per assicurarci che tutto nel contratto sia corretto. Questo è un processo manuale, quindi i tempi di elaborazione potrebbero variare, ma lo faremo il più velocemente possibile.",
						"content": {
							"title": "Per assicurarti che la valutazione sia fatta il più velocemente possibile, controlla che i dati seguenti siano visibili sul tuo sito:",
							"list": {
								"default": {
									"item_1": "Il nome registrato della tua azienda",
									"item_2": "Il numero registrato della tua azienda",
									"item_3": "L’indirizzo registrato della tua azienda",
									"item_4": "Politica dei resi che contempli almeno 14 giorni",
									"item_5": "Email o numero dell’assistenza clienti"
								},
								"US": {
									"item_1": "Il nome registrato dell’azienda",
									"item_2": "Politica dei resi",
									"irem_3": "Email o numero dell’assistenza clienti"
								},
								"AU": {
									"item_1": "ABM (numero dell’azienda) o Nome di attività registrato.",
									"item_3": "L’indirizzo registrato della tua azienda",
									"item_4": "Politica dei resi che contempli almeno 14 giorni",
									"item_5": "Email o numero dell’assistenza clienti"
								}
							}
						},
						"footer": "Ti invieremo una email una volta che la valutazione è completata o se necessiteremo ulteriori informazioni da parte tua."
					},
					"suspended": {
						"title": "Purtroppo…",
						"subtitle": "Dopo aver valutato i dettagli del tuo contratto, abbiamo dovuto rifiutare la tua richiesta. Ci possono essere svariate ragioni per cui la tua richiesta non è stata approvata. Qui di seguito sono elencati alcuni dei fattori più comuni:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Il tuo negozio non rispetta le linee guida etiche di Klarna.",
								"item_2": "La persona di contatto indicata non è raggiungibile.",
								"item_3": "Altri fattori tecnici o amministrativi."
							}
						},
						"footer": "Grazie per aver dimostrato interesse in Klarna. Contattaci se hai ulteriori domande o se vuoi iscriverti in futuro con un negozio differente."
					},
					"disabled": {
						"title": "La tua richiesta è stata disabilitata.",
						"subtitle": "Il tuo account è stato automaticamente disabilitato perché mancante di informazioni richieste per legge.",
						"content": {
							"title": "Questo di solito succede quando Klarna ti ha chiesto di fornire alcune informazioni e non hai risposto prima della data di scadenza specificata."
						},
						"footer": "Se credi che si tratti di un errore o vuoi inviare di nuovo le informazioni, contatta il Supporto Merchant usando le informazioni di contatto che trovi in fondo a questa pagina."
					},
					"ready_to_connect": {
						"title": "Collega il tuo negozio",
						"subtitle": "Il tuo contratto è completato e puoi ora integrare Klarna nel tuo negozio. Segui i passi qui di seguito per completare l’integrazione.",
						"status_messsage": {
							"title": "Integrazione non ancora completata",
							"subtitle": "Segui le istruzioni di integrazione per collegare il tuo negozio. Questo stato diventerà verde non appena viene effettuata una transazione con Klarna."
						},
						"content": {
							"title": "Istruzioni",
							"options": {
								"label_1": "Genera e salva le tue credenziali API Klarna",
								"description_1": "Genera nuove credenziali API e scaricale sul tuo computer. Avrai bisogno di queste credenziali API nella prossima sezione.",
								"label_2": "Installa Klarna nel tuo negozio Shopify"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Abbiamo quasi finito",
						"subtitle": "Sei a pochi passi dall’offrire un’esperienza di shopping ancora più smoooth ai tuoi clienti! Il tuo contratto è completato e il tuo negozio è pronto per l’integrazione",
						"buttons": {
							"connect": "Collega il tuo negozio"
						},
						"additional_info": "Tieni presente che l’integrazione sarà considerata completa solo quando riceveremo il primo acquisto, il che potrebbe richiedere un po’ di tempo a seconda della tua piattaforma."
					},
					"store_connected": {
						"title": "Il tuo negozio è connesso",
						"subtitle": "L’integrazione del tuo negozio a Klarna è completa e i tuoi clienti sono in grado di pagare utilizzando Klarna.",
						"status_messsage": {
							"title": "Integrazione riuscita con successo",
							"subtitle": "Una transazione Klarna è stata elaborata con successo nel tuo negozio.",
							"button_text": {
								"shown": "Visualizza le istruzioni di integrazione",
								"hidden": "Nascondi le istruzioni di integrazione"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "La tua richiesta",
							"subtitle": "Controlla le informazioni della tua richiesta.",
							"button_text": "Visualizza sommario"
						},
						"connect_store": {
							"title": "Credenziali API Klarna",
							"subtitle": "Genera credenziali API Klarna per integrare il tuo negozio.",
							"button_text": "Genera credenziali API Klarna"
						},
						"add_product": {
							"title": "Articoli",
							"subtitle": "Clicca qui se vuoi aggiungere un prodotto a questa installazione.",
							"button_text": "Aggiungi prodotti"
						}
					},
					"timeline": {
						"application": {
							"title": "La tua richiesta",
							"alert": {
								"view_summary": "Visualizza sommario",
								"rejected": "Abbiamo dovuto respingere la tua richiesta.",
								"review": "Rivedi i dati della tua richiesta facendo clic sul link riportato di seguito."
							}
						},
						"payouts": {
							"title": "Pagamenti abilitati"
						},
						"integration": {
							"title": "Integrazione non ancora completata",
							"alert": "Segui le istruzioni di integrazione per collegare il tuo negozio."
						},
						"integration_complete": {
							"title": "Integrazione completata!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Congratulazioni, l’installazione è completata!",
						"rejection": "Spiacenti, non abbiamo potuto completare l’installazione."
					},
					"header_new": {
						"title": "Benvenuto, Commerciante Klarna",
						"subtitle": "Riepilogo",
						"rejection": "Richiesta rifiutata"
					},
					"joy_section": {
						"approved": {
							"title": "Approvata!",
							"content": "La tua richiesta è stata esaminata e approvata. Il pieno accesso ai servizi Klarna è ora a portata di clic. Siamo entusiasti di poter lavorare con te!",
							"button_title": "Controlla i tuoi ordini",
							"link": "o le nostre risorse di marketing"
						},
						"rejected": {
							"title": "Purtroppo…",
							"content_1": "Dopo aver esaminato la tua richiesta, non possiamo approvare il tuo contratto come commerciante.",
							"content_2": "Non esitare a contattare il nostro team di supporto se hai qualche domanda."
						}
					},
					"sidebar_left": {
						"application_details": "I dati della tua richiesta",
						"store_details": {
							"title": "Informazioni sul negozio",
							"text_blocks": [
								{
									"text": "Un riepilogo dei tuoi dati"
								}
							]
						},
						"credentials": {
							"title": "Credenziali API Klarna",
							"text_blocks": [
								{
									"text": "Le tue credenziali API Klarna"
								}
							]
						},
						"payouts": {
							"title": "Pagamenti",
							"text_blocks": [
								{
									"text": "I tuoi dati bancari inviati"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Conti bancari aggiuntivi",
							"text_block": null
						},
						"business_owners": {
							"title": "Proprietari d’impresa",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Persone di grande influenza",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Parti interessate",
							"text_blocks": [
								{
									"text": "Le tue informazioni inviate"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Proprietari d’impresa",
								"no_elements": "Non hai indicato alcun proprietario d’impresa"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Conto bancario predefinito",
								"no_elements": "Nessun conto bancario predefinito disponibile"
							},
							"additional_bank_accounts": {
								"title": "Conti bancari aggiuntivi",
								"no_elements": "Non hai presentato alcun conto bancario aggiuntivo"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Proprietari",
								"no_elements": "Non hai indicato alcun proprietario"
							},
							"ultimate_beneficial_owner": {
								"title": "Beneficiari effettivi",
								"no_elements": "Non hai indicato alcun beneficiario effettivo"
							},
							"applicant": {
								"title": "Candidati",
								"no_elements": "Non hai indicato alcun candidato"
							},
							"control_over_management": {
								"title": "Persone con controllo sulla gestione",
								"no_elements": "Non hai indicato alcuna parte interessata con controllo sulla gestione"
							}
						},
						"buttons": {
							"back": "Indietro",
							"next_step": "Prossimo"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Abbiamo già i tuoi dati",
							"text_blocks": [
								{
									"text": "Queste sono le informazioni che ci hai già dato in precedenza."
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Non hai indicato alcun proprietario d’impresa"
						},
						"buttons": {
							"submit": "Invia",
							"back": "Indietro"
						}
					}
				},
				"checking_page": {
					"title": "Verifica in corso…",
					"subtitle": "Grazie per aver inviato la richiesta. Attendi mentre la stiamo esaminando…"
				},
				"success_page": {
					"title": "Puoi ora collegare il tuo negozio",
					"subtitle": "Ti ringraziamo per aver inviato la richiesta.",
					"buttons": {
						"next": "Prossimo"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "le basi",
						"business": "Attività",
						"stakeholders": "Parti interessate",
						"bank_accounts": "Conti correnti"
					}
				},
				"app_error": {
					"title": "L’app Articoli è al momento non disponibile",
					"message": "Si sono verificati dei problemi con la tua richiesta e stiamo già indagando. Tentiamo di risolvere i problemi il prima possibile. Riprova più tardi."
				},
				"temporarily_down": {
					"title": "Abbiamo delle difficoltà tecniche",
					"message": "Ci scusiamo per ogni inconveniente causato e ti assicuriamo che stiamo facendo del nostro meglio per risolvere il problema. Riprova più tardi."
				},
				"maintenance_mode": {
					"title": {
						"products_app": "La nostra app Articoli è al momento fuori servizio per manutenzione",
						"signup_app": "La nostra app di iscrizione è attualmente offline per manutenzione"
					},
					"message": "Stiamo lavorando per migliorare la tua esperienza e speriamo di riuscirci il prima possibile. Riprova più tardi."
				},
				"unknown_merchant": {
					"before_link": "Se hai già un accordo con noi, visita",
					"link_text": "questa pagina",
					"after_link": "per scoprire di più sui nostri prodotti!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Si è verificato un errore.",
						"invalid_token": "Questo link è scaduto"
					},
					"message": {
						"invalid_token_risk": " Contattaci sul canale Slack #smooothforce-support e ti aiuteremo.",
						"invalid_token": "Mettiti in contatto con il tuo contatto di vendita.",
						"invalid_flow_type": "Il tipo e lo stato della registrazione di questo commerciante sono incompatibili. Se credi che sia un errore, contatta il Supporto Merchant."
					}
				},
				"topbar": {
					"title": "Installazione",
					"widget_type": {
						"MANAGED_KYC": "Raccolta KYC",
						"MANAGED_RISK": "Raccolta di prevalutazione",
						"MANAGED_SME_RISK": "Raccolta SME di prevalutazione"
					}
				},
				"product_card": {
					"incompatible_description": "Non disponibile per il tuo Paese o la tua piattaforma",
					"kco_footer_text": "I metodi di pagamento disponibili nel Klarna Checkout dipendono dal tuo Paese di registrazione e dal paese in cui tu vendi.",
					"products_link_text": "Altro"
				},
				"product_prices_card": {
					"title": "Articoli",
					"subtitle": "{country}",
					"pricing": "Prezzi per {country}",
					"monthly_fee": "commissione mensile",
					"transaction_fee": "commissione sulla transazione",
					"before_link": "Accetto i",
					"link_text": "Termini e condizioni",
					"after_link_one_product": "di Klarna per questo prodotto",
					"after_link_more_than_one_product": "di Klarna per questi prodotti",
					"product_not_available_in_your_country": "* Questo prodotto non è disponibile per il tuo mercato nazionale, ma sarà disponibile in altri paesi.",
					"edit_link": "Modifica",
					"merchant_agreement": {
						"before_link": "Accetto il",
						"link_text": "Accordo per i Commercianti",
						"after_link_one_product": "di Klarna per questo prodotto",
						"after_link_more_than_one_product": "di Klarna per questi prodotti"
					},
					"pricing_annex": {
						"before_link": "Accetto il",
						"link_text": "Condizioni tariffarie",
						"after_link_one_product": "di Klarna per questo prodotto"
					}
				},
				"support_footer": {
					"text": "Supporto in inglese",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Tutti i diritti riservati.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Termini e condizioni.",
					"privacy_policy": "Informativa sulla privacy",
					"merchant_id": "Merchant ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Supporto Merchant",
					"recaptcha": {
						"1_main_text": "Questo sito è protetto da reCAPTCHA e si applicano",
						"2_privacy_policy": "l’Informativa sulla Privacy",
						"3_and": "e",
						"4_terms_of_service": "i Termini del Servizio",
						"5_apply": "di Google."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Prezzi per tutti i nostri mercati",
					"title_us": "Prezzi",
					"subtitle": "Ti viene addebitata solo una commissione per transazione, smoooth!",
					"table": {
						"country": "Paese",
						"price_column_heading": "Commissione per transazione",
						"global": "Globale",
						"title": {
							"kp": "Metodi di pagamento",
							"kco": "Checkout Klarna",
							"kco_one": "Checkout Klarna",
							"kp_one": "Metodi di pagamento Klarna"
						},
						"headers": {
							"kp_one": "Commissioni"
						}
					},
					"buttons": {
						"back": "Indietro"
					},
					"foot_notes": {
						"global_price": "* Valuta locale del commerciante, altrimenti "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Prima transazione",
						"content": "Prima di poter esaminare i tuoi dati sui pagamenti abbiamo bisogno di un primo ordine. Non vuoi sprecare i tuoi soldi? Nessun problema!",
						"button": "Simula la transazione!"
					},
					"transactions": {
						"title": "Transazioni approvate",
						"content": "Puoi semplicemente simulare l’approvazione della transazione",
						"button": "Approva"
					},
					"payouts": {
						"title": "Approva pagamenti",
						"content": "Puoi semplicemente simulare l’approvazione del pagamento",
						"button": "Approva"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Conto bancario predefinito",
						"additional": "Conto bancario aggiuntivo {index}",
						"normal": "Conto bancario {index}"
					},
					"currency_code": {
						"label": "Valuta"
					},
					"country_of_bank_account": {
						"label": "Paese"
					},
					"account_number": {
						"label": {
							"default": "Numero di conto",
							"MX_LOCAL": "Numero CLABE"
						}
					},
					"account_holder": {
						"label": "Intestatario del conto"
					},
					"routing_number": {
						"label": "Coordinate bancarie"
					},
					"transit_number": {
						"label": "Numero di serie"
					},
					"institution_number": {
						"label": "Numero dell’istituzione"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB"
						}
					},
					"no_edit_button": "Puoi modificare le informazioni sul conto bancario una volta completata la registrazione"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Nome legale dell’azienda"
					},
					"country": {
						"label": "Paese"
					},
					"registrationId": {
						"label": {
							"default": "Codice fiscale aziendale",
							"AT": "Codice fiscale aziendale",
							"AU": "ACN",
							"CA": "Numero dell’azienda",
							"ES": "NIF/NIE/DNI aziendale",
							"GB": "Organizzazione numero",
							"GR": "Numero G.E.MI. (Γ.Ε.ΜΗ.)",
							"US": "Numero d’identificazione del datore di lavoro"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Tribunale di registrazione"
					},
					"goodsCategory": {
						"label": "Categoria merceologica"
					},
					"registered": {
						"label": {
							"default": "Azienda registrata",
							"AU": "L’azienda ha un ACN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Azienda soggetta a IVA",
							"AU": "Azienda soggetta a ABN",
							"ES": "L’azienda ha un NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "Numero partita IVA",
							"AU": "ABN",
							"ES": "NIF/NIE/DNI aziendale"
						}
					},
					"storeName": {
						"label": "Nome negozio online"
					},
					"website": {
						"label": "Sito web"
					},
					"email": {
						"label": "Email Supporto clienti"
					},
					"entityType": {
						"label": "Tipo di entità"
					},
					"toc_data": {
						"label": "Termini e condizioni",
						"toc_approval_text": {
							"before_link": "I tuoi",
							"link_text": "Termini e Condizioni",
							"after_link": "accettati il giorno {date}",
							"merchant_agreement": {
								"before_link": "I tuoi",
								"link_text": "Accordo per i Commercianti",
								"after_link": "accettati il giorno {date}"
							},
							"pricing_annex": {
								"before_link": "I tuoi",
								"link_text": "Allegato Prezzi",
								"after_link": "accettati il giorno {date}"
							}
						}
					},
					"companyName": {
						"label": "Nome della collaborazione"
					},
					"registeredCompanyName": {
						"label": "Nome azienda"
					},
					"address": {
						"label": "Indirizzo"
					},
					"operatingAddress": {
						"label": "Indirizzo operativo"
					},
					"organizationEntityType": {
						"label": "Classificazione fiscale"
					}
				},
				"api_key_dialog": {
					"title": "Credenziali API Klarna generate",
					"subtitle": "Le credenziali verranno mostrate solo una volta. Clicca sul bottone sottostante per scaricare le tue credenziali prima di chiudere questa finestra.",
					"key_box": {
						"username": {
							"label": "Nome utente API Klarna"
						},
						"password": {
							"label": "Password API Klarna"
						},
						"file_name": "Klarna_credentials"
					},
					"buttons": {
						"download": "Scarica come .txt"
					}
				},
				"platform_instructions": {
					"step": "Passo {current}/{max}",
					"next": "Prossimo",
					"back": "Indietro",
					"shopify": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopify, segui la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guida estesa sull’integrazione."
								}
							]
						},
						{
							"title": "Installa Klarna nel tuo negozio Shopify",
							"step_instructions": [
								[
									{
										"text": "Vai sull’"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Installazione guidata dei Metodi di pagamento Klarna con Shopify."
									}
								],
								[
									{
										"text": "Segui le istruzioni per completare l’integrazione."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopify, segui la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guida estesa sull’integrazione."
								}
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta \"Integrazione completata\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopify, segui la"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "guida estesa sull’integrazione."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Abilita il plugin Klarna Payment Method per Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Per poter installare il plugin Klarna, hai bisogno di un sistema funzionante di Plentymarkets CERES. Il"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "plugin Ceres"
									},
									{
										"text": "è disponibile da scaricare da plentyMarketplace. Da lì, sarai anche reindirizzato alle"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "istruzioni per l’installazione."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni dettagliate riguardanti l’integrazione Klarna con Plentymarkets Ceres, vai a"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "questo link."
									}
								]
							]
						},
						{
							"title": "Installazione e configurazione",
							"step_instructions": [
								[
									{
										"text": "L’installazione del Plugin Klarna viene effettuata attraverso il"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Vieni anche reindirizzato al plentyMarketplace dal backend del sistema plentymarkets. Le"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "istruzioni su come installare i plugin in plentymarkets"
									},
									{
										"text": "si trovano su plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni dettagliate riguardanti l’integrazione Klarna con Plentymarkets Ceres, vai a"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "questo link."
									}
								]
							]
						},
						{
							"title": "Configurazione del plugin",
							"step_instructions": [
								[
									{
										"text": "Il plugin è configurato direttamente nel set corrispondente. Cliccando sulla linea del"
									},
									{
										"bold": "plugin Klarna"
									},
									{
										"text": "la pagina di configurazione si apre."
									}
								],
								[
									{
										"text": "La configurazione è divisa in due aree:"
									},
									{
										"list": [
											[
												{
													"bold": "Autenticazione:"
												},
												{
													"text": "La modalità è utilizzata per determinare se è in fase di test o produttiva. A seconda della modalità, il nome utente e la password devono essere salvati."
												}
											],
											[
												{
													"bold": "Impostazioni generali:"
												},
												{
													"text": "Qui selezioni il prodotto che vuoi utilizzare. O i singoli metodi di pagamento di Klarna (Klarna Payments) o l’intero checkout di Klarna (Klarna Checkout). Quando selezioni il checkout, il checkout nel negozio sarà automaticamente sovrascritto dal Klarna Checkout."
												}
											]
										]
									},
									{
										"text": "Non ci sono ulteriori impostazioni necessarie e se si disattiva il plugin questo sarà annullato."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni dettagliate riguardanti l’integrazione Klarna con Plentymarkets Ceres, vai a"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "questo link."
									}
								]
							]
						},
						{
							"title": "Informazioni finali",
							"step_instructions": [
								[
									{
										"text": "Sono richiesti i seguenti requisiti di sistema:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets versione 7"
											},
											{
												"text": "Plugin Ceres e IO installati"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni dettagliate riguardanti l’integrazione Klarna con Plentymarkets Ceres, vai a"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "questo link."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Abilita il plugin Klarna Checkout per WooCommerce",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato il plugin Klarna Checkout per WooCommerce. Se ancora non hai il plugin, dirigiti su"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								],
								[
									{
										"text": "Una volta che hai le tue credenziali API Klarna, vai su “Impostazioni” e poi “Checkout” nel pannello di WooCommerce. Scegli Klarna Checkout."
									}
								],
								[
									{
										"text": "Abilita Klarna Checkout mettendo la spunta sulla casella Abilita Klarna Checkout."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, dai un’occhiata alla loro"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guida estesa."
									}
								]
							]
						},
						{
							"title": "Configura le impostazioni",
							"step_instructions": [
								[
									{
										"text": "Configura le impostazioni per Klarna Checkout. Nota che il campo “Titolo” è utilizzato per impostare il titolo del metodo di pagamento visualizzato nel tuo checkout, e per le email di conferma dell’ordine (per es. Klarna Checkout)."
									}
								],
								[
									{
										"text": "Spunta la casella “Modalità test” se vuoi creare ordini usando le credenziali di test."
									}
								],
								[
									{
										"text": "È ora il momento di compilare le impostazioni del Paese. Se sei in Europa, clicca su “Espandi” nella sezione europea. Se sei negli Stati Uniti, clicca su “Espandi” nella sezione degli Stati Uniti."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, dai un’occhiata alla loro"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guida estesa."
									}
								]
							]
						},
						{
							"title": "Aggiungi le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Aggiungi le tue credenziali API Klarna nei campi nome utente API Klarna e password API Klarna."
									}
								],
								[
									{
										"text": "Salva le tue impostazioni."
									}
								],
								[
									{
										"text": "L’ultima cosa da fare è impostare il Klarna Checkout come metodo predefinito di pagamento. Vai in “Impostazioni” e poi “Pagamenti” nel tuo pannello WooCommerce. Trova la sezione “Metodi di pagamento” e imposta Klarna Checkout come metodo predefinito di pagamento."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, dai un’occhiata alla loro"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guida estesa."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Assicurati di abilitare"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "permalink gradevoli"
									},
									{
										"text": "nella tua installazione WordPress. Altrimenti i callback da Klarna al tuo negozio non funzioneranno e gli ordini non saranno aggiornati con lo stato dell’ordine o le informazioni corrette."
									}
								],
								[
									{
										"text": "Se desideri gestire il tuo ordine Klarna direttamente in WooCommerce devi allora installare il plugin"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Gestione Ordini Klarna"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Assicurati che Klarna Checkout venga visualizzato come previsto, aggiungendo un articolo al tuo carrello e procedendo al checkout (non effettuare effettivamente un ordine)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, dai un’occhiata alla loro"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "guida estesa."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, segui la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Installa ed abilita il plugin Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Installa il"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "plugin Klarna Payment Method per WooCommerce."
									}
								],
								[
									{
										"text": "Nel tuo account WooCommerce vai in"
									},
									{
										"bold": "Impostazioni → Pagamenti → Klarna Payment Method."
									}
								],
								[
									{
										"text": "Abilita Klarna Payment Method mettendo la spunta sulla casella Abilita Klarna Payment Method."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, segui la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Configura le impostazioni del tuo Paese",
							"step_instructions": [
								[
									{
										"text": "Compila le impostazioni del Paese. Ogni Paese Klarna ha il suo proprio set di impostazioni specifiche per il Paese. Aggiungendo credenziali commerciante a uno specifico Paese puoi anche abilitare Klarna Payment Method come un metodo di pagamento disponibile per quel Paese."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, segui la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Inserisci le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Inserisci le tue credenziali API Klarna nei campi nome utente API Klarna e password API Klarna."
									}
								],
								[
									{
										"text": "Salva le tue impostazioni."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, segui la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta \"Integrazione completata\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di WooCommerce, segui la"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Configura le impostazioni per abilitare Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato il plugin Klarna Checkout per Magento. Se ancora non hai il modulo, dirigiti su"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								],
								[
									{
										"text": "Una volta che hai le tue credenziali API Klarna, apri il pannello di Magento. Vai in “Negozi” → “Configurazione” → “Vendite” → “Metodi di pagamento” → “Klarna” → “API Klarna”."
									}
								],
								[
									{
										"text": "Espandi la sezione “API Klarna” e inserisci la tua versione API, il nome utente API Klarna e la password API Klarna. Assicurati di disabilitare la modalità di test se vuoi procedi col mettere online il tuo sito."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Magento, dai un’occhiata alla loro"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "guida estesa."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Quando le impostazioni sono configurate, hai bisogno di controllare che Klarna Checkout sia abilitato nelle tue opzioni di checkout."
									}
								],
								[
									{
										"text": "Vai su “Negozi” → “Configurazione” → “Vendite” → “Checkout” → “Opzioni Klarna Checkout” nel tuo pannello Magento."
									}
								],
								[
									{
										"text": "Klarna Checkout deve essere abilitato come predefinito. Se non lo è, cambia ad"
									},
									{
										"bold": "Abilita"
									},
									{
										"text": "sotto “Abilita Klarna Checkout”."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							]
						},
						{
							"title": "Installa e attiva il modulo Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Visita"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Impostare Klarna sulla guida all’utente Magento"
									},
									{
										"text": "e segui là le istruzioni per installare e configurare il modulo nel tuo account Magento."
									}
								]
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta \"Integrazione completata\"."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Abilita il plugin Klarna Payment Method per Shopware",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato il plugin Klarna Payment Method per Shopware. Se ancora non hai il plugin, dirigiti su"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								],
								[
									{
										"text": "In un passo successivo avrai bisogno di importare il plugin Klarna Payment Method in Shopware cliccando su"
									},
									{
										"bold": "Configurazione → Plugin manager → Installati → Aggiorna plugin."
									},
									{
										"text": "Clicca"
									},
									{
										"bold": "Seleziona"
									},
									{
										"text": "sul file .zip del plugin Klarna Payment Method e selezionalo. Conferma cliccando su"
									},
									{
										"bold": "Aggiorna plugin."
									},
									{
										"text": "Il plugin ora potrà essere ritrovato nel plugin manager."
									}
								],
								[
									{
										"text": "Installa il plugin cliccando sull’icona"
									},
									{
										"bold": "“+” verde"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configura il plugin Klarna Payment Method per Shopware",
							"step_instructions": [
								[
									{
										"text": "Naviga alle impostazioni del plugin cliccando su"
									},
									{
										"bold": "Configurazione → Impostazioni di base → Cerca Klarna Payment Method"
									}
								],
								[
									{
										"text": "Inserisci nei campi le tue credenziali API Klarna"
									},
									{
										"bold": "Nome utente API Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "Password API Klarna"
									},
									{
										"text": "e salva le modifiche."
									}
								],
								[
									{
										"text": "Assicurati di usare la modalità live e di utilizzare le tue credenziali API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configura i gateway per Klarna Payment",
							"step_instructions": [
								[
									{
										"text": "Prima di utilizzare Klarna hai bisogno di attivare i gateway per Klarna Payment Method. Puoi trovarli cliccando su"
									},
									{
										"bold": "Configurazione → Metodi di pagamento"
									}
								],
								[
									{
										"text": "Come default tutti i gateway di Klarna Payment Method sono installati. Apri i gateway di Klarna Payment Method a cui ti sei iscritto e attivali spuntando la casella"
									},
									{
										"bold": "Attivato"
									},
									{
										"text": ". Salva le modifiche."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configura i costi di spedizione",
							"step_instructions": [
								[
									{
										"text": "Configura i costi d spedizione per i gateway Klarna Payment Method cliccando su"
									},
									{
										"bold": "Configurazione → Costi di spedizione"
									}
								],
								[
									{
										"text": "Seleziona i metodi di spedizione che devono essere disponibili per Klarna cliccando"
									},
									{
										"bold": "sull’icona con la matita."
									}
								],
								[
									{
										"text": "Seleziona la scheda Selezione del metodo di pagamento e muovi i tuoi gateway Klarna Payment Method da"
									},
									{
										"bold": "Disponibili"
									},
									{
										"text": "a"
									},
									{
										"bold": "Selezionati."
									},
									{
										"text": "Salva le tue impostazioni"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Attivi Klarna Payment Method(s).",
							"step_instructions": [
								[
									{
										"text": "Il prossimo passo è quello di attivare il plugin Klarna Payment Method. Clicca su"
									},
									{
										"bold": "Configurazione → Plugin manager → Installati"
									},
									{
										"text": "per raggiungere il Plugin manager."
									}
								],
								[
									{
										"text": "Attiva il plugin cliccando sull’icona con una"
									},
									{
										"bold": "“X” rossa"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ti verrà chiesto se vuoi svuotare la cache. Clicca su"
									},
									{
										"bold": "Sì."
									},
									{
										"text": "Tieni presente che devi svuotare la cache e compilare i temi ogni volta che cambi qualcosa nelle impostazioni del modulo o nei metodi di pagamento di Klarna."
									}
								],
								[
									{
										"text": "Per attivare totalmente il plugin Klarna Payment Method il tema del negozio deve essere ricompilato. Clicca su"
									},
									{
										"bold": "Compila temi"
									},
									{
										"text": "quando viene richiesto."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Per evitare errori di arrotondamento, assicurati di avere l’estensione PHP bcmath installata sul tuo server. Troverai la guida"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "qui"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Riavvia il tuo backend una volta per assicurarti che tutte le configurazioni siano disponibili nel tuo negozio."
									}
								],
								[
									{
										"text": "Assicurati che i tuoi prodotti Klarna Payments vengano visualizzati come previsto aggiungendo un articolo al carrello, scegliendo Klarna come metodo di pagamento e procedendo alla cassa (ma non effettuare realmente l’ordine)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Abilita il plugin Klarna Checkout per Shopware",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato il plugin Klarna Checkout per Shopware (versione 5.2.17 e successive). Se ancora non hai il plugin, dirigiti su"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								],
								[
									{
										"text": "In un passo successivo avrai bisogno di importare il plugin Klarna Checkout in Shopware cliccando su"
									},
									{
										"bold": "Configurazione → Plugin manager → Installati → Aggiorna plugin."
									},
									{
										"text": "Clicca"
									},
									{
										"bold": "Seleziona"
									},
									{
										"text": "sul file .zip del plugin Klarna Checkout e selezionalo. Conferma cliccando su"
									},
									{
										"bold": "Aggiorna plugin."
									},
									{
										"text": "Il plugin ora potrà essere ritrovato nel plugin manager."
									}
								],
								[
									{
										"text": "Installa il plugin cliccando sull’icona"
									},
									{
										"bold": "“+” verde"
									},
									{
										"text": "."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configura il plugin Klarna Checkout per Shopware",
							"step_instructions": [
								[
									{
										"text": "Naviga alle impostazioni del plugin cliccando su"
									},
									{
										"bold": "Configurazione → Impostazioni di base → Cerca Klarna Checkout"
									}
								],
								[
									{
										"text": "Inserisci nei campi le tue credenziali API Klarna"
									},
									{
										"bold": "Nome utente API Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "Password API Klarna"
									},
									{
										"text": "e salva le modifiche."
									}
								],
								[
									{
										"text": "Assicurati di usare la modalità live e di utilizzare le tue credenziali API Klarna."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Attiva il gateway per i pagamenti con Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Prima di utilizzare Klarna hai bisogno di attivare i gateway Klarna Payments. Puoi trovarli cliccando su"
									},
									{
										"bold": "Configurazione → Metodi di pagamento"
									}
								],
								[
									{
										"text": "Apri il gateway Klarna Checkout e attivalo mettendo la spunta sulla casella"
									},
									{
										"bold": "Attivato"
									},
									{
										"text": ". Salva le modifiche."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configura i costi di spedizione",
							"step_instructions": [
								[
									{
										"text": "Configura i costi d spedizione per i gateway Klarna Checkout cliccando su"
									},
									{
										"bold": "Configurazione → Costi di spedizione"
									}
								],
								[
									{
										"text": "Seleziona i metodi di spedizione che devono essere disponibili per Klarna cliccando"
									},
									{
										"bold": "sull’icona con la matita."
									}
								],
								[
									{
										"text": "Seleziona la scheda Selezione del metodo di pagamento e muovi Klarna Checkout da"
									},
									{
										"bold": "Disponibile"
									},
									{
										"text": "a"
									},
									{
										"bold": "Selezionato."
									},
									{
										"text": "Salva le tue impostazioni"
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Attiva il tuo plugin Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Il prossimo passo è quello di attivare il plugin Klarna Checkout. Clicca su"
									},
									{
										"bold": "Configurazione → Plugin manager → Installati"
									},
									{
										"text": "per raggiungere il Plugin manager."
									}
								],
								[
									{
										"text": "Attiva il plugin cliccando sull’icona con una"
									},
									{
										"bold": "“X” rossa"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Ti verrà chiesto se vuoi svuotare la cache. Clicca su"
									},
									{
										"bold": "Sì."
									}
								],
								[
									{
										"text": "Per attivare totalmente il plugin Klarna Checkout il tema del negozio deve essere ricompilato. Clicca su"
									},
									{
										"bold": "Compila temi"
									},
									{
										"text": "quando viene richiesto."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Per evitare errori di arrotondamento, assicurati di avere l’estensione PHP bcmath installata sul tuo server. Troverai la guida"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "qui"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Assicurati che “Indirizzo aggiuntivo linea 1” e “Indirizzo aggiuntivo linea 2” non siano marcati come campi obbligatori."
									}
								],
								[
									{
										"text": "Riavvia il tuo backend una volta per assicurarti che tutte le configurazioni siano disponibili nel tuo negozio."
									}
								],
								[
									{
										"text": "Assicurati che Klarna Checkout venga visualizzato come previsto, aggiungendo un articolo al carrello, scegliendo Klarna come metodo di pagamento e procedendo alla cassa (ma non effettuare realmente l’ordine)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Abilita il plugin Klarna Payment Method per Shopware",
							"step_instructions": [
								[
									{
										"text": "Per poter installare il plugin Klarna è necessario un sistema funzionante di Shopware 6. Le linee guida per l’installazione possono essere trovate"
									},
									{
										"link": "https://docs.shopware.com/en/shopware-6-en/first-steps/installing-shopware-6",
										"text": "qui."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Installazione e configurazione. Ci sono svariati modi di installare il plugin Klarna.",
							"step_instructions": [
								[
									{
										"text": "Prima esecuzione guidata."
									}
								],
								[
									{
										"text": "Installazione tramite Amministrazione."
									}
								],
								[
									{
										"text": "Installazione tramite download diretto dal community store."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Attiva il plugin Klarna Payment Method per Shopware",
							"step_instructions": [
								[
									{
										"text": "Vai alla panoramica dei plugin nell’Amministrazione Shopware. Puoi accedervi andando su"
									},
									{
										"bold": "Impostazioni > Sistema > Plugin."
									}
								],
								[
									{
										"text": "Seleziona"
									},
									{
										"bold": "Installa"
									},
									{
										"text": "dal menu contestuale (\"…\"). Riceverai un messaggio da Shopware che il plugin è stato installato correttamente."
									}
								],
								[
									{
										"text": "Per ragioni di sicurezza il plugin è ora installato ma non ancora attivato. È necessario ottimizzarlo prima con i tuoi dati di accesso e le impostazioni individuali."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Procedura guidata",
							"step_instructions": [
								[
									{
										"text": "Dopo che il plugin è stato attivato, vai su"
									},
									{
										"bold": "menu contestuale (\"…\") > procedura guidata.",
										"text": "In seguito ci sarà un reindirizzamento alla routine."
									}
								],
								[
									{
										"text": "La routine ti guiderà attraverso l’intero processo di installazione e ti permetterà di registrarti con Klarna se non hai ancora un account rivenditore."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Configurazione del plugin",
							"step_instructions": [
								[
									{
										"bold": "Canali di vendita."
									},
									{
										"text": "Qui si stabilisce se le seguenti impostazioni per \"tutti i canali di vendita\" devono essere usate o applicate solo a certi canali di vendita individuali."
									}
								],
								[
									{
										"bold": "Impostazioni API."
									},
									{
										"text": "Nome utente API e password API: Inserisci qui i tuoi dati di accesso API per la modalità live e di test nelle sezioni appropriate."
									}
								],
								[
									{
										"text": "Puoi testare le tue credenziali API Klarna cliccando sul pulsante"
									},
									{
										"bold": "Testa il pulsante delle credenziali API,",
										"text": "che si trova in alto. Riceverai successivamente un messaggio di successo o un’indicazione che i dati paiono errati."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Attiva o disattiva il plugin",
							"step_instructions": [
								[
									{
										"text": "Se desideri attivare o disattivare il plugin Klarna Payment Method o vuoi solamente vedere lo stato di attivazione, vai nell’Amministrazione Shopware e seleziona"
									},
									{
										"bold": "Impostazioni > Sistema > Plugin."
									}
								],
								[
									{
										"text": "Qui puoi visualizzare lo stato attuale nella tabella sotto"
									},
									{
										"bold": "\"I miei plugin\"."
									}
								],
								[
									{
										"text": "Lo stato può essere cambiato cliccando sulla barra di scorrimento."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Per evitare errori di arrotondamento, assicurati di utilizzare PHP in versione 7.2 o superiore."
									}
								],
								[
									{
										"text": "Completa l’installazione di Shopware"
									},
									{
										"bold": "(Storefront + Amministrazione, non headless)."
									}
								],
								[
									{
										"text": "Il sistema deve essere accessibile dall’esterno per aggiornare lo stato dei pagamenti."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di Shopware, guarda la nostra"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "guida estesa (in tedesco)."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di 3dcart, segui la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Attiva Klarna Payment Method nello Store Manager Online",
							"step_instructions": [
								[
									{
										"text": "Accedi allo"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "Store Manager Online di 3dcart"
									},
									{
										"text": "e vai su"
									},
									{
										"bold": "Impostazioni → Pagamenti."
									}
								],
								[
									{
										"text": "Nella pagina dei pagamenti clicca sul pulsante"
									},
									{
										"bold": "Seleziona Metodi di pagamento"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Verrà visualizzata una lista di moduli preinstallati. Localizza il modulo Klarna e attivalo usando la levetta."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di 3dcart, segui la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Inserisci le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Dopo aver attivato il modulo, inserisci il tuo nome utente Klarna API (UID) nel campo corrispondente. Lo troverai nel file delle credenziali che hai precedentemente scaricato."
									}
								],
								[
									{
										"text": "Poi clicca sul link"
									},
									{
										"bold": "Modifica password"
									},
									{
										"text": "e inserisci la password API Klarna nel campo della password."
									}
								],
								[
									{
										"text": "Sotto"
									},
									{
										"bold": "Lingua del Paese"
									},
									{
										"text": "seleziona la lingua che verrà utilizzata per le opzioni nei pagamenti Klarna nel negozio."
									}
								],
								[
									{
										"text": "Al di sopra del campo nome utente c’è una casella di spunta accanto a"
									},
									{
										"bold": "\"Modalità di test\"."
									},
									{
										"text": "Seleziona questa opzione per attivare la modalità di prova, permettendoti di effettuare ordini senza incorrere in spese o azioni di pagamento mentre stai testando il modulo."
									}
								],
								[
									{
										"text": "Una volta che hai terminato con la configurazione delle tue impostazioni, clicca su \"Salva\" in alto a destra."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di 3dcart, segui la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta \"Integrazione completata\"."
									}
								],
								[
									{
										"text": "Se nel passo precedente avevi attivato la “Modalità di test”, torna indietro, deseleziona l’opzione e salva prima di mettere il tuo negozio online, in modo che i tuoi clienti possano fare ordini reali."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Per ottenere informazioni più dettagliate sull’integrazione di 3dcart, segui la"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "guida estesa sull’integrazione."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di BigCommerce, segui la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guida estesa sull’integrazione."
								}
							]
						},
						{
							"title": "Configura le impostazioni di BigCommerce",
							"step_instructions": [
								[
									{
										"text": "In BigCommerce, vai su"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Impostazioni del negozio › Pagamenti,"
									},
									{
										"text": "ed espandi la sezione Metodi di pagamento online. Poi clicca su"
									},
									{
										"bold": "Configura"
									},
									{
										"text": "accanto al metodo di pagamento Klarna."
									}
								],
								[
									{
										"text": "Questo ti reindirizzerà alla scheda Impostazioni di Klarna Payment Method. Accedi al file delle credenziali API che hai salvato nella sezione precedente e copia il nome utente e la password nei campi corrispondenti."
									}
								],
								[
									{
										"text": "Salva le tue modifiche quando hai terminato."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di BigCommerce, segui la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guida estesa sull’integrazione."
								}
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta \"Integrazione completata\"."
									}
								]
							],
							"alternate": [
								{
									"text": "Per ottenere informazioni più dettagliate sull’integrazione di BigCommerce, segui la"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "guida estesa sull’integrazione."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Attiva il modulo Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato il modulo ufficiale Klarna per Prestashop. Se ancora non ce l’hai, dirigiti su"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								],
								[
									{
										"text": "Ti informiamo che dal 1 gennaio 2023 i plugin sviluppati e creati da Prestasworks A.B (SI) non saranno più disponibili gratuitamente. Se vuoi usufruire dei servizi offerti da Klarna puoi decidere se comprare il plugin o attendere il rilascio dei plugin di Klarna previsto per il secondo trimestre del 2023."
									}
								],
								[
									{
										"text": "Accedi nella pagina d’amministrazione Prestashop e vai su"
									},
									{
										"bold": "Moduli → Moduli."
									}
								],
								[
									{
										"text": "Cerca “Klarna” usando la barra di ricerca per localizzare il modulo Klarna by Prestaworks AB. Clicca"
									},
									{
										"bold": "Configura."
									}
								]
							]
						},
						{
							"title": "Configura le impostazioni del modulo Klarna",
							"step_instructions": [
								[
									{
										"text": "Sei ora sulla pagina delle impostazioni del modulo. In cima a “Impostazioni generali” vedrai un pulsante chiamato"
									},
									{
										"bold": "Attiva KCO in questo negozio"
									},
									{
										"text": "(Klarna Checkout V3). Scegli"
									},
									{
										"bold": "Sì."
									}
								],
								[
									{
										"text": "Clicca"
									},
									{
										"bold": "Salva"
									},
									{
										"text": "per salvare le tue impostazioni."
									}
								],
								[
									{
										"text": "Ora, clicca su paese di vendita nel menu a sinistra, e inserisci le tue credenziali API Klarna dove c’è scritto"
									},
									{
										"bold": "Nome utente API Klarna"
									},
									{
										"text": "e"
									},
									{
										"bold": "Password API Klarna."
									}
								],
								[
									{
										"text": "Clicca"
									},
									{
										"bold": "Salva."
									}
								]
							]
						},
						{
							"title": "Ultimi passi",
							"step_instructions": [
								[
									{
										"text": "Controlla che la modalità di test sia disabilitata se è il momento di mettere online il tuo sito. Puoi farlo nella scheda"
									},
									{
										"bold": "Impostazioni generali."
									},
									{
										"text": "Il pulsante"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "deve essere impostato su"
									},
									{
										"bold": "No."
									}
								],
								[
									{
										"text": "Quando sei in"
									},
									{
										"bold": "Impostazioni generali,"
									},
									{
										"text": "assicurati di configurare le tue impostazioni per come vuoi gestire gli ordini, le impostazioni per l’invio delle fatture e così via."
									}
								],
								[
									{
										"text": "Assicurati che Klarna Checkout venga visualizzato come previsto, aggiungendo un articolo al carrello e procedendo alla cassa (ma non effettuare realmente l’ordine)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							]
						},
						{
							"title": "Installa e attiva il modulo Klarna Payment Method",
							"step_instructions": [
								[
									{
										"text": "Apri la"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "pagina di istruzioni per Klarna Payment Method in Prestashop"
									},
									{
										"text": "e segui le istruzioni per installare e configurare il modulo nel tuo account Prestashop."
									}
								]
							]
						},
						{
							"title": "Effettua un acquisto di prova",
							"step_instructions": [
								[
									{
										"text": "Per poter verificare che l’integrazione sia configurata correttamente, effettua un acquisto di prova nel tuo negozio."
									}
								],
								[
									{
										"text": "Dopo aver effettuato l’ordine, vai su"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "Ordini nel Portale Merchant,"
									},
									{
										"text": "trova il tuo ordine e cancellalo, per evitare di doverlo pagare."
									}
								],
								[
									{
										"text": "Una volta che la tua integrazione è riuscita, il banner in alto su questa pagina diventerà verde mostrando la scritta “Integrazione completata”."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Genera le tue credenziali API Klarna.",
							"step_instructions": [
								[
									{
										"text": "Queste credenziali saranno necessarie per integrare Klarna nel tuo negozio."
									}
								]
							]
						},
						{
							"title": "Aggiungi Klarna come metodo di pagamento.",
							"step_instructions": [
								[
									{
										"text": "Nel pannello di amministrazione di Jumpseller, vai su Impostazioni > Pagamenti, trova “Klarna” tra le varie caselle di controllo e fai clic su “Aggiungi metodo”."
									}
								]
							]
						},
						{
							"title": "Configura il tuo nuovo metodo di pagamento.",
							"step_instructions": [
								[
									{
										"text": "Nel pannello di amministrazione di Klarna (dal pannello di amministrazione di Jumpseller vai su Impostazioni > Pagamenti > Klarna): (1) aggiungi le credenziali API di Klarna generate inizialmente, (2) seleziona i pacchetti EMD che vuoi/devi condividere con Klarna e (3) se vuoi acquisire automaticamente gli ordini (l’impostazione predefinita è “no”)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Integra Lightspeed eCom",
							"step_instructions": [
								[
									{
										"text": "Qui puoi trovare la guida di integrazione in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Inglese"
									},
									{
										"text": "e in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Olandese"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Integra Shoper",
							"step_instructions": [
								[
									{
										"text": "Visualizza la guida alla pagina"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "il sito web di Shoper"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Integra Timma",
							"step_instructions": [
								[
									{
										"text": "Visualizza la guida alla pagina"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "il sito web di Timma"
									},
									{
										"text": "."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							]
						},
						{
							"title": "Integra con SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Segui le istruzioni presenti sul"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "sito web di SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Genera e salva le tue credenziali API Klarna",
							"step_instructions": [
								[
									{
										"text": "Genera nuove credenziali API e scarica il file sul tuo computer. Apri il file e tienilo aperto, perché avrai bisogno di queste credenziali API nella prossima sezione."
									}
								]
							]
						},
						{
							"title": "Integra con Workstand",
							"step_instructions": [
								[
									{
										"text": "Segui le istruzioni presenti sul"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "sito web di Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Leggi la documentazione del nostro plugin",
							"step_instructions": [
								[
									{
										"text": "Vai sulla"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "pagina della nostra documentazione"
									}
								]
							]
						},
						{
							"title": "Attiva il modulo Klarna Checkout per JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato l’estensione ufficiale Klarna. Se ancora non ce l’hai,"
									},
									{
										"text": "dirigiti su"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Leggi la documentazione del nostro plugin",
							"step_instructions": [
								[
									{
										"text": "Vai sulla"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "pagina della nostra documentazione"
									}
								]
							]
						},
						{
							"title": "Attiva il modulo Klarna Payments per JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Prima di tutto, assicurati di aver installato l’estensione ufficiale Klarna. Se ancora non ce l’hai,"
									},
									{
										"text": "dirigiti su"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "questa pagina"
									},
									{
										"text": "per ottenerlo."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Ecco cosa devi fare successivamente",
							"step_instructions": [
								[
									{
										"bold": "Genera le tue credenziali API Klarna."
									},
									{
										"text": "Queste credenziali sono necessarie per integrare Klarna nel tuo negozio."
									}
								],
								[
									{
										"bold": "Aggiungi le credenziali API Klarna nel tuo sistema di backend per abilitare Klarna."
									},
									{
										"text": "Dai un’occhiata al nostro"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Portale Sviluppatori"
									},
									{
										"text": "per ricevere maggiore supporto."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Nome",
							"error": "Inserisci un nome"
						},
						"last_name": {
							"label": "Cognome",
							"error": "Inserisci un cognome"
						},
						"dateOfBirth": {
							"label": {
								"default": "Data di nascita (GG/MM/AAAA)",
								"without_format": "Data di nascita",
								"US": "Data di nascita (MM/GG/AAAA)"
							},
							"error": "Inserisci una data di nascita valida",
							"error_too_young": "Devi avere almeno 18 anni per vendere con Klarna"
						},
						"address": {
							"label": "Indirizzo di residenza",
							"error": "Inserisci un indirizzo"
						},
						"city": {
							"label": "Città",
							"error": "Inserisci una città"
						},
						"country": {
							"label": "Paese",
							"error": "Seleziona un Paese"
						},
						"postal_code": {
							"label": {
								"default": "Codice postale",
								"US": "Codice postale"
							},
							"error": {
								"default": "Inserisci un codice postale valido",
								"US": "Inserisci un codice postale valido"
							}
						},
						"region": {
							"label": "Stato/regione (opzionale)",
							"label_summary": "Stato/regione"
						},
						"state": {
							"label": "Stato",
							"error": "Inserisci uno stato"
						},
						"role_question": {
							"OWNER": "Questa persona è un proprietario?",
							"BENEFICIAL_OWNER": "Questa persona controlla più del 25% delle azioni o dei diritti di voto?",
							"ULTIMATE_BENEFICIAL_OWNER": "Questo individuo è proprietario o controlla più del 25% delle azioni o dei diritti di voto"
						},
						"is_person_pep": [
							{
								"text": "Questo individuo è una"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "persona politicamente esposta (PPE)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un parente stretto"
							},
							{
								"text": "o"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "un collega o collaboratore"
							},
							{
								"text": "di tale persona?"
							}
						],
						"pep_relationship": {
							"label": "Relazione",
							"error": "Selezionare la relazione che questa persona ha con una PPE"
						},
						"pep_position": {
							"label": "Posizione di PPE",
							"error": "Selezionare la posizione che la PPE ricopre"
						},
						"personal_id_question": "Questa persona non è in possesso di un Numero di Identificazione Personale",
						"personal_id": {
							"US": {
								"label": "Numero di previdenza sociale (ultimi 4 numeri)",
								"label_summary": "Numero di previdenza sociale"
							},
							"US_FULL_SSN": {
								"label": "Numero di previdenza sociale",
								"label_summary": "Numero di previdenza sociale"
							},
							"CA": {
								"label": "Numero di previdenza sociale o numero di passaporto",
								"label_summary": "Numero di previdenza sociale o numero di passaporto"
							},
							"SE": {
								"label": "Numero di identificazione personale (PNO)",
								"label_summary": "Numero di identificazione personale (PNO)"
							},
							"FI": {
								"label": "Codice di identificazione personale (HETU)",
								"label_summary": "Numero di identificazione personale (HETU)"
							},
							"NO": {
								"label": "Numero nazionale d’identità",
								"label_summary": "Numero nazionale d’identità"
							},
							"DK": {
								"label": "Numero personale d’identificazione",
								"label_summary": "Numero personale d’identificazione (CPR)"
							},
							"IT": {
								"label": "Codice fiscale",
								"label_summary": "Codice fiscale"
							},
							"ES": {
								"label": "Numero personale d’identificazione",
								"label_summary": "Documento Nazionale di Identità (DNI)"
							},
							"PL": {
								"label": "Numero personale d’identificazione",
								"label_summary": "Numero di identificazione personale (PESEL)"
							},
							"default": {
								"label": "Numero di passaporto",
								"label_summary": "Numero di passaporto"
							},
							"value": "Riservato"
						},
						"registration_number": {
							"label": "Numero d’identificazione dell’impresa",
							"error": "Inserisci EIN nel formato: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Nome negozio",
							"error": "Fornisci un nome di azienda valido"
						},
						"legal_company_name": {
							"label": "Nome legale dell’azienda",
							"error_label": "Fornisci il nome legale dell’azienda"
						},
						"add_person": "Aggiungi persona",
						"remove": "Rimuovi",
						"edit": "Modifica"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Merchant ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Risorse di marketing",
						"text": "Ora fai parte della famiglia Klarna! Ecco qui un pacchetto di materiale e ancora di più per permetterti di operare.",
						"link": "Download"
					},
					"invite_more_users": {
						"title": "Invita più utenti",
						"text": "Invita i tuoi collaboratori al Portale Merchant, sarete in grado di impostare autorizzazioni personalizzate per ciascuno di loro!",
						"link": "Invita utenti"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Prodotti e prezzi",
					"subtitle": "{country}",
					"pricing": "Prezzi per {country}",
					"monthly_fee": "commissione mensile",
					"transaction_fee": "commissione sulla transazione",
					"before_link": "Accetto i",
					"link_text": "Termini e Condizioni",
					"after_link_one_product": "di Klarna per questo prodotto",
					"after_link_more_than_one_product": "di Klarna per questi prodotti",
					"product_not_available_in_your_country": "* Questo prodotto non è disponibile per il tuo mercato nazionale, ma sarà disponibile in altri paesi."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installazione effettuata"
						},
						"in_progress": {
							"text": "In corso"
						}
					}
				},
				"phone_collection_block": {
					"title": "Hai bisogno di aiuto con l'integrazione di Klarna?",
					"description": "Lascia il tuo numero qui sotto e uno dei nostri agenti ti contatterà per aiutarti ad aggiungere Klarna al tuo e-commerce.",
					"success_banner": "Grazie! Il nostro team ti contatterà il più presto possibile.",
					"submit": "Invia",
					"fields": {
						"phone": {
							"label": "Numero di telefono",
							"tooltip": "Devi includere il codice del Paese, per es. +1 541 754 3010",
							"errors": {
								"required": "Il numero di telefono è obbligatorio",
								"invalid": "Numero di telefono non valido"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Chi si occupa di firmare i contratti nella tua azienda?",
						"managed": "Chi si occupa di firmare i contratti per l'azienda?",
						"recollection": "Chi è autorizzato a firmare per conto della tua azienda?"
					},
					"subtitle": {
						"unmanaged": "La tua azienda sta per stipulare un accordo con Klarna. Abbiamo bisogno di verificare chi sia legalmente autorizzato a firmare contratti.",
						"managed": "Fornisci le informazioni riguardo tutti i firmatari autorizzati della tua azienda che aderiscono all’accordo. Siamo tenuti per legge a convalidare il potere di firma di questi rappresentanti. Se nessuno dalla lista ha firmato l’accordo clicca su “Aggiungi persona” e fornisci le informazioni richieste.",
						"recollection": "Poiché la tua azienda ha un accordo attivo con Klarna, siamo legalmente obbligati a raccogliere e verificare le informazioni su tutti i tuoi rappresentanti legali."
					},
					"form_title": "Inserisci le informazioni",
					"robot_message": {
						"unmanaged": "Questi sono di solito i direttori del consiglio di amministrazione o dirigenti come CEO, CFO o COO. L'inserimento di due o più persone può aiutare ad accelerare l'approvazione del contratto.",
						"managed": "Questi sono di solito i direttori del consiglio di amministrazione o dirigenti come CEO, CFO o COO. L'inserimento di due o più persone può aiutare ad accelerare l'approvazione del contratto."
					},
					"error_tooltip": {
						"too_young": "Questa persona non può inviare la domanda perché anno meno di {minAge} anni."
					},
					"alert_all_too_young": "Tutte le persone che stipulano il contratto devono avere più di {minAge} anni. Per continuare, aggiungi e seleziona un richiedente che abbia più di {minAge} anni.",
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro",
						"add_person": "+ Aggiungi persona"
					},
					"role": {
						"recollection": "Rappresentante legale"
					}
				},
				"application_summary": {
					"title": "Rivedi e invia la tua richiesta.",
					"subtitle": {
						"unmanaged": "Dai un’occhiata ai tuoi dati prima di inviare.",
						"managed": "Dai un’occhiata ai dati prima di inviare."
					},
					"stakeholders": {
						"title": "Gestione aziendale",
						"subtitle": "Parti interessate {index}"
					},
					"businessDetailsCard": {
						"title": "Dati dell’attività"
					},
					"businessDetailsCardFields": {
						"companyName": "Nome azienda",
						"organizationEntityType": "Classificazione fiscale",
						"organizationRegistrationAuthority": "Tribunale di registrazione",
						"goodsCategory": "Categoria merceologica",
						"registrationId": {
							"default": "Codice fiscale aziendale",
							"AT": "Codice fiscale aziendale",
							"AU": "ACN",
							"CA": "Numero dell’azienda",
							"ES": "NIF/NIE/DNI aziendale",
							"GB": "Organizzazione numero",
							"GR": "Numero G.E.MI. (Γ.Ε.ΜΗ.)",
							"NZ": "Numero dell’azienda",
							"US": "Numero d’identificazione del datore di lavoro"
						},
						"registered": {
							"default": "Azienda registrata",
							"AU": "L’azienda ha un ACN"
						},
						"subjectToVat": {
							"default": "Azienda soggetta a IVA",
							"AU": "Azienda soggetta a ABN"
						},
						"vatId": {
							"default": "Numero partita IVA",
							"AU": "ABN",
							"NZ": "Numero GST",
							"ES": "NIF/NIE/DNI aziendale"
						},
						"storeName": "Nome negozio",
						"storeName_us": "Nome del brand/ DBA",
						"website": "Sito web",
						"email": "Email Supporto clienti",
						"entityType": "Tipo di entità"
					},
					"companyRegistrationAddressCard": {
						"title": "Indirizzo registrato dell’azienda"
					},
					"companyAddressCard": {
						"title": "Indirizzo dell’azienda"
					},
					"operatingAddressCard": {
						"title": "Indirizzo operativo dell’azienda"
					},
					"documentsCard": {
						"title": "Documenti caricati"
					},
					"buttons": {
						"edit": "Modifica",
						"back": "Indietro",
						"submit": "Invia"
					},
					"noTermsAccepted": "Si prega di leggere e accettare i termini e le condizioni.",
					"noTermsAcceptedWithPricingAnnex": "Si prega di leggere e accettare l'accordo per i Commercianti e le condizioni tariffarie."
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Chi gestisce l’azienda?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Siamo legalmente obbligati dalla direttiva antiriciclaggio dell’UE ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						],
						"US": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"CA": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						]
					},
					"infobox": {
						"default": "Inserisci le informazioni personali e l’indirizzo di residenza del CEO dell’azienda.",
						"US": "Inserisci le informazioni personali e l'indirizzo di residenza del proprietario di maggioranza o di un manager di alto livello come il CEO, il Direttore finanziario o il Direttore operativo.",
						"CA": "Inserisci le informazioni personali e l’indirizzo di residenza del proprietario di maggioranza o di un manager di alto livello come il CEO, il Direttore finanziario o il Direttore operativo."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Quest’azienda è una impresa quotata in borsa o è di proprietà esclusiva di un’impresa quotata in borsa?",
					"title_stakeholder": "Chi gestisce l’azienda?",
					"subtitle": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni.",
					"subtitle_stakeholder": "Inserisci le informazioni personali e l’indirizzo di residenza del CEO dell’azienda.",
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"bank_account": {
					"title": {
						"default": "Quali sono le tue coordinate bancarie?"
					},
					"subtitle": {
						"US": "Le transazioni Klarna saranno trasferite a questo conto bancario.",
						"default": "Useremo questi dati bancari per accreditare gli importi dovuti."
					},
					"no_more_bank_accounts": "Hai già aggiunto conti bancari per tutte le valute supportate. Ottimo lavoro!",
					"robot_message_general": "Il conto bancario predefinito deve essere con una banca del Paese in cui la società è registrata. È inoltre necessario un conto bancario per ciascuna valuta che hai in mente di accettare.",
					"robot_message": "IBAN significa International Bank Account Number (Numero di conto bancario internazionale) ed è fornito dalla banca per ogni conto. Per es.: GB98 MIDL 0700 9312 3456 78",
					"robot_message_account_number": {
						"AU": "Il numero di conto è fornito dalla tua banca e deve contenere tra i 6 e i 10 caratteri. Per es.: 12345678",
						"US": "Il numero di conto è fornito dalla tua banca e deve contenere tra i 5 e i 17 caratteri. Per es.: 12345678",
						"GB": "Il numero del conto corrente è fornito dalla banca ed è composto da 8 cifre. Ad esempio: 12345678. Alcune banche del Regno Unito forniscono numeri di conto più corti (ad es. di 7 cifre). In questo caso verranno aggiunti degli zeri all’inizio del numero per arrivare a 8 cifre."
					},
					"robot_message_revolut": "L’IBAN da te fornito non può ricevere pagamenti domestici in GBP. Dovrai contattare la tua banca e richiedere i dettagli di un conto che supporti i trasferimenti nazionali in GBP.",
					"robot_message_local": "L’IBAN che hai fornito è un IBAN locale della tua banca, che non è supportato da noi. Dovrai contattare la tua banca e richiedere il tuo IBAN personale oppure utilizzare un altro conto per collegarti a Klarna.",
					"buttons": {
						"add_bank_account": "+ Aggiungi conto bancario",
						"skip": "Salta (per ora)",
						"remove": "Rimuovi",
						"submit": "Invia",
						"next": "Prossimo",
						"back": "Indietro"
					},
					"fields": {
						"currency_code": {
							"label": "Valuta",
							"disable_reason": {
								"account_in_merchant_currency_required": "La valuta predefinita è {currency} visto che la registrazione della tua azienda è avvenuta in quella nazione."
							},
							"errors": {
								"general": "Seleziona una valuta"
							}
						},
						"country_of_bankaccount": {
							"label": "Paese",
							"errors": {
								"general": "Seleziona un Paese"
							}
						},
						"iban_account_number": {
							"label": "Numero di conto (IBAN)",
							"errors": {
								"general": "Inserisci un numero di conto bancario (IBAN)"
							}
						},
						"use_as_default_bank_account": {
							"label": "Usa questo conto per valute non specificate",
							"tooltip": "Gli ordini effettuati con valute non elencate in questa pagina non saranno addebitati su questo conto. La tua banca potrebbe addebitarti un costo aggiuntivo per determinate valute."
						},
						"local_account_number": {
							"label": {
								"default": "Numero di conto",
								"MX": "Numero CLABE"
							},
							"errors": {
								"general": {
									"default": "Inserisci un numero di conto bancario valido",
									"MX": "Inserisci un numero CLABE valido"
								}
							}
						},
						"account_holder": {
							"label": "Intestatario del conto",
							"errors": {
								"general": "Inserisci il nome del titolare del conto (massimo 70 caratteri)."
							}
						},
						"transit_number": {
							"label": "Numero di serie",
							"errors": {
								"general": "Inserisci un numero di serie valido"
							}
						},
						"institution_number": {
							"label": "Numero dell’istituzione",
							"errors": {
								"general": "Inserisci un numero di istituzione valido"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB"
							},
							"errors": {
								"general": {
									"AU": "Inserisci una succursale bancaria statale (BSB) valida"
								}
							},
							"tooltip": {
								"AU": "Il codice BSB deve contenere 6 cifre numeriche divise da un trattino. Ad esempio: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Coordinate bancarie",
								"GB": "Sort code"
							},
							"errors": {
								"general": {
									"default": "Inserisci coordinate bancarie valide",
									"GB": "Inserisci un codice "
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Chi gestisce l’azienda?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Siamo legalmente obbligati dalla direttiva antiriciclaggio dell’UE ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						],
						"GB": [
							{
								"text": "Siamo obbligati per legge a raccogliere queste informazioni. Assicurati che i dati forniti alla Companies House siano aggiornati."
							}
						]
					},
					"infobox": "Inserisci le informazioni personali e l’indirizzo di residenza delle persone che esercitano il controllo sulla gestione dell’azienda, come l’amministratore delegato o i membri del consiglio di amministrazione.",
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro",
						"add_person": "+ Aggiungi persona"
					},
					"messages": {
						"lookup": "Queste persone gestiscono la tua azienda? Dai un’occhiata e conferma la correttezza delle informazioni."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "La tua azienda è una società registrata?",
						"managed": "Questa azienda è una società registrata?"
					},
					"subtitle": {
						"unmanaged": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
						"managed": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività."
					},
					"question": {
						"title": {
							"unmanaged": "Inserisci il numero e il tribunale di registrazione",
							"managed": "Inserisci il codice fiscale aziendale e il tribunale di registrazione"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Codice fiscale aziendale"
						},
						"registration_court": {
							"label": "Tribunale di registrazione",
							"errors": {
								"general": {
									"unmanaged": "Seleziona il tribunale di registrazione",
									"managed": "Seleziona il tribunale di registrazione"
								}
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"documents": {
					"title": "Carica il tuo documento",
					"subtitle": "Ti chiediamo di mandarci alcuni documenti aggiuntivi necessari per poter verificare la tua identità. Carica solo file <strong>JPG</strong>, <strong>PNG</strong> o <strong>PDF</strong> (dimensione massima del file 10 MB).",
					"subheadline": {
						"default": "Klarna è una banca con sede legale in Svezia, regolamentata dall'Autorità di Vigilanza finanziaria svedese. In quanto tale, Klarna ha l’obbligo di operare in conformità con la / nel rispetto della Direttiva UE 2015/849. Di conseguenza abbiamo bisogno di raccogliere informazioni sulle persone che controllano l'azienda, in modo che tu possa iniziare ad utilizzare i servizi di Klarna. Ti informiamo che per procedere con l'attivazione del servizio è necessaria la registrazione presso la Camera di Commercio. Carica solo file in formato <strong>JPG, PNG o PDF</strong> (dimensioni file max. 10 MB)",
						"US": "Klarna è una banca con sede legale in Svezia, regolamentata dall’Autorità di vigilanza finanziaria svedese. In quanto tale, Klarna ha l’obbligo di operare in conformità con la / nel rispetto della Direttiva UE 2015/849. Prima di iniziare a utilizzare i nostri servizi, siamo tenuti a raccogliere alcune informazioni sui dirigenti dell’azienda. Per verificare la tua identità abbiamo bisogno dei seguenti documenti. Carica solo file JPG, PNG o PDF (dimensione massima del file 10 MB).",
						"IT": "Klarna è una banca con sede legale in Svezia, regolamentata dall'Autorità di Vigilanza finanziaria svedese. In quanto tale, Klarna ha l’obbligo di operare in conformità con la / nel rispetto della Direttiva UE 2015/849. Di conseguenza abbiamo bisogno di raccogliere informazioni sulle persone che controllano l'azienda, in modo che tu possa iniziare ad utilizzare i servizi di Klarna. Ti informiamo che per procedere con l'attivazione del servizio è necessaria la registrazione presso la Camera di Commercio. Carica solo file in formato JPG, PNG o PDF (dimensioni file max. 10 MB)"
					},
					"header_title": "Documenti",
					"stakeholder": "Parte interessata",
					"business_documents": "Documenti aziendali",
					"browse_files": "Naviga tra i file",
					"optional": "(facoltativo)",
					"upload_area": {
						"title": {
							"before_link": "Trascina qui i tuoi file o",
							"link_text": "Seleziona i file"
						},
						"description": "{acceptedFileFormats} - Massimo {maxFileSizeMB} MB per file"
					},
					"description": {
						"APPROVAL": "Carica <strong>approvazione</strong>",
						"CONTRACT": "Carica <strong>contratto</strong>",
						"CORRECTION_NOTE": "Carica <strong>nota correttiva</strong>",
						"COUNTERSIGNED_CONTRACT": "Carica <strong>contratto controfirmato</strong>",
						"ID_DOCUMENT": "Carica <strong>carta d’identità</strong> o <strong>passaporto</strong>",
						"LICENSE": "Carica <strong>patente</strong>",
						"PROOF_OF_ADDRESS": "Carica <strong>prova di residenza</strong>",
						"SPECIAL_AGREEMENT": "Carica <strong>accordo speciale</strong>",
						"SUPPORTING_DOCUMENT": "Carica <strong>documento di supporto</strong>",
						"TAX_OFFICE_REGISTRATION": "Carica <strong>registrazione a fini fiscali</strong>"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Approvazione"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Contratto"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Nota correttiva"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Contratto controfirmato"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Carta d'Identita'",
								"IT": "Carta d'Identita'"
							},
							"subtitle": {
								"default": "Fornisci entrambi i lati della carta d’identità.",
								"AT": "Inviaci una copia fronte/retro del tuo documento d’identità. Se il documento d’identità non riporta il tuo indirizzo di residenza, dovrai inviarci un’ulteriore documentazione (ad es. una bolletta) che attesti la tua identità.",
								"AU": "Per elaborare la richiesta nel minor tempo possibile, inviaci la copia del documento d’identità completo di foto delle seguenti persone associate all’azienda (ad es. un passaporto o una patente di guida australiana). Per le Ditte individuali / Società di persone: documento del titolare o dei titolari. Società di capitali: documento del rappresentante legale, degli amministratori e di tutti gli azionisti che detengono almeno il 25% delle quote azionarie.",
								"BE": "Assicurati che le copie dei documenti inviati siano fronte/retro, che la qualità delle immagini sia buona e che tutte le informazioni siano chiaramente leggibili.",
								"DE": "Inviaci una copia fronte/retro del tuo documento d’identità. Se il documento d’identità non riporta il tuo indirizzo di residenza, dovrai inviarci un’ulteriore documentazione (ad es. una bolletta) che attesti la tua identità.",
								"FR": "Assicurati che le copie dei documenti inviati siano fronte/retro, che la qualità delle immagini sia buona e che tutte le informazioni siano chiaramente leggibili.",
								"GB": "Fornisci un documento d’identità, se è una carta d’identità servono entrambi i lati.",
								"IT": "Una carta di identità valida fronte/retro per ciascuna delle persone elencate nell’applicazione. Patente di guida, passaporto, carta/numero di previdenza sociale <strong>non possono essere accettati</strong>.",
								"NL": "Assicurati che le copie dei documenti inviati siano fronte/retro, che la qualità delle immagini sia buona e che tutte le informazioni siano chiaramente leggibili.",
								"US": "Patente di guida o passaporto: inviare una copia fronte/retro."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Patente"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Conferma dell'indirizzo",
								"BE": "Conferma dell'indirizzo",
								"CZ": "Conferma dell'indirizzo",
								"ES": "Conferma dell'indirizzo",
								"FI": "Conferma dell'indirizzo",
								"FR": "Conferma dell'indirizzo",
								"GR": "Conferma dell'indirizzo",
								"IT": "Conferma dell'indirizzo",
								"NL": "Conferma dell'indirizzo",
								"PL": "Conferma dell'indirizzo",
								"PT": "Conferma dell'indirizzo"
							},
							"subtitle": {
								"default": "Se la tua Carta d'Identita' ha un indirizzo differente dal tuo attuale indirizzo di residenza, ci servira' un documento aggiuntivo per verificare la tua residenza attuale. Accettiamo uno a scelta dei seguenti documenti, non più vecchi di 3 mesi, come prova dell'indirizzo di residenza delle persone indicate nella richiesta: certificato di residenza rilasciato online (tramite SPID) oppure dal Comune di residenza, una bolletta intestata di elettricità / acqua / gas / wi-fi, contratto di locazione.",
								"AU": "Per elaborare la tua richiesta nel minor tempo possibile e verificare il tuo indirizzo di residenza, inviaci uno dei seguenti documenti relativi agli ultimi 90 giorni: Bollette, bolletta internet, dichiarazione dei redditi o contratto di leasing/locazione. *Questo passaggio è obbligatorio nel caso in cui venga inviata una copia del passaporto o il tuo indirizzo attuale non corrisponde a quello riportato sul documento.",
								"BE": "Come prova del tuo indirizzo di residenza accettiamo i seguenti documenti relativi agli ultimi 3 mesi: Bollette di energia elettrica, acqua, gas, dichiarazione dei redditi o contratto di leasing. Se non dovessi disporre di nessuno di questi documenti, inviacene un altro recante il tuo indirizzo di residenza e aggiungi una nota spiegandone la motivazione.",
								"FR": "Come prova del tuo indirizzo di residenza accettiamo i seguenti documenti relativi agli ultimi 3 mesi: Bollette di energia elettrica, acqua, gas, dichiarazione dei redditi o contratto di leasing. Se non dovessi disporre di nessuno di questi documenti, inviacene un altro recante il tuo indirizzo di residenza e aggiungi una nota spiegandone la motivazione.",
								"NL": "Come prova del tuo indirizzo di residenza accettiamo i seguenti documenti relativi agli ultimi 3 mesi: Bollette di energia elettrica, acqua, gas, dichiarazione dei redditi o contratto di leasing. Se non dovessi disporre di nessuno di questi documenti, inviacene un altro recante il tuo indirizzo di residenza e aggiungi una nota spiegandone la motivazione.",
								"US": "Accettiamo bollette (di gas, acqua, internet, telefono), contratti di leasing o mutuo nei quali sia chiaramente riportato il tuo indirizzo di residenza. Questa documentazione non deve essere antecedente agli ultimi 90 giorni.",
								"IT": "Se la tua Carta d'Identita' ha un indirizzo differente dal tuo attuale indirizzo di residenza, ci servira' un documento aggiuntivo per verificare la tua residenza attuale. Accettiamo uno a scelta dei seguenti documenti, non più vecchi di 3 mesi, come prova dell'indirizzo di residenza delle persone indicate nella richiesta:"
							},
							"list": {
								"IT": [
									{
										"text": "Certificato di residenza rilasciato online (tramite SPID) oppure dal Comune di residenza"
									},
									{
										"text": "Bolletta intestata di elettricità / acqua / gas / wi-fi"
									},
									{
										"text": "Contratto di locazione"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Accordo speciale"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Documenti di supporto",
								"GB": "Selfie"
							},
							"subtitle": {
								"default": null,
								"AU": "Se la tua attività prevede la vendita di costosi articoli di marca, inviaci 2 o 3 fatture emesse dai tuoi fornitori relativamente a tali prodotti. Assicurati che queste fatture indichino chiaramente i prodotti acquistati, il nome del fornitore, il nome del destinatario e l’indirizzo di consegna.",
								"GB": "Invia un selfie mostrando il documento d’identità"
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Documento di registrazione con l’ufficio fiscale",
								"AT": "Documento di registrazione presso l’autorità fiscale",
								"AU": "Atto costitutivo di trust",
								"BE": "Partita IVA abilitata alle transazioni transfrontaliere (VIES).",
								"DE": "Documento di registrazione presso l’autorità fiscale",
								"FR": "Partita IVA abilitata alle transazioni transfrontaliere (VIES).",
								"IT": "Partita IVA abilitata alle transazioni transfrontaliere (VIES).",
								"NL": "Partita IVA abilitata alle transazioni transfrontaliere (VIES).",
								"NO": "Registrazione a fini fiscali",
								"US": "Codice EIN"
							},
							"subtitle": {
								"default": null,
								"AT": "Accettiamo i seguenti documenti relativi alla tua azienda: Certificato di iscrizione al Registro delle imprese / licenza ditta individuale",
								"AU": "Se il tuo ABN è associato a un trust, inviaci una copia del documento di trust, incluso il piano. Questo passaggio è obbligatorio per le società che si avvalgono del trust.",
								"BE": "Poiché Klarna è una società estera, verifica che il tuo numero di VAT sia abilitato per le transazioni transfrontaliere anche se operi solo ed esclusivamente nel tuo Paese. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Per richiedere l’attivazione gratuita del VIES per il tuo numero di VAT contatta l’Ufficio locale predisposto alla riscossione delle imposte.",
								"CZ": "Accettiamo i seguenti documenti relativi alla tua azienda: Certificato di iscrizione della tua ditta individuale al Public Registry o al Registro delle imprese.",
								"DE": "Accettiamo i seguenti documenti relativi alla tua azienda: Certificato di iscrizione al Registro delle imprese / licenza ditta individuale",
								"ES": "Come documenti aziendali accettiamo i seguenti documenti: Atti di costituzione per le imprese integratrici; per le ditte individuali - Certificato di situazione censuaria / Modello 036 / Modello 037",
								"FI": "Accettiamo i seguenti documenti come documenti aziendali: Atti costitutivi per ditte individuali - Certificazione della situazione censuaria / Modello 036 / Modello 037",
								"FR": "Poiché Klarna è una società estera, verifica che il tuo numero di VAT sia abilitato per le transazioni transfrontaliere anche se operi solo ed esclusivamente nel tuo Paese. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Per richiedere l’attivazione gratuita del VIES per il tuo numero di VAT contatta l’Ufficio locale predisposto alla riscossione delle imposte.",
								"GR": "Accettiamo i seguenti documenti relativi alla tua azienda: Registrazione presso l’ufficio predisposto alla riscossione delle imposte / Data di inizio attività / Documento del Registro delle imprese rilasciato dal General Commercial Registry (GEMI) competente",
								"IT": "Puoi contattare l'Agenzia delle Entrate per richiedere l'attivazione gratuita del VIES della Partita IVA. Questa operazione sara’ necessaria anche se commerci solo in Italia, in quanto Klarna è un'entità estera.",
								"NL": "Poiché Klarna è una società estera, verifica che il tuo numero di VAT sia abilitato per le transazioni transfrontaliere anche se operi solo ed esclusivamente nel tuo Paese. https://ec.europa.eu/taxation_customs/vies/#/vat-validation Per richiedere l’attivazione gratuita del VIES per il tuo numero di VAT contatta l’Ufficio locale predisposto alla riscossione delle imposte.",
								"NO": "Accettiamo i seguenti documenti relativi alla tua azienda: Documenti relativi alla società",
								"PL": "Accettiamo i seguenti documenti relativi alla tua azienda: Certificato di registrazione al CEIDG, estratto del Registro Nazionale dei Tribunali (KRS)",
								"PT": "Accettiamo i seguenti documenti commerciali: Certidão Permanente (obbligatorio), Atto costitutivo. Per le ditte individuali, la dichiarazione di inizio attività (Declaração de Início de Atividade). ",
								"US": "Si tratta della lettera ricevuta dall’IRS nella quale ti viene assegnato un EIN (IRS CP575 Codice EIN). Se la tua è una ditta individuale e disponi di un Social security number, inviacene una copia fronte/retro"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Documento d’identità certificato"
							},
							"subtitle": {
								"default": "Accettiamo i seguenti documenti: Carta d’identità, passaporto, patente di guida. I documenti devono soddisfare i seguenti criteri:"
							},
							"list": [
								{
									"text": "Essere certificati da un’autorità competente (ad esempio un notaio, un commissario con potere certificante, un avvocato, un procuratore e/o un commercialista)."
								},
								{
									"text": "Essere firmati e stampati. La stampa deve riportare chiaramente i dati dell’autorità certificante quali nome e cognome, indirizzo e, laddove presente, il numero di registrazione."
								},
								{
									"text": "Essere datati e riportare una data non antecedente agli ultimi 6 mesi."
								},
								{
									"text": "Essere certificati come copia conforme all’originale indicando la corretta presa visione del documento originale."
								}
							]
						}
					},
					"modal": {
						"title": "Perché ci servono i tuoi documenti?",
						"close": "Chiudi",
						"content": [
							{
								"title": "Descrizione della procedura",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Requisiti dei file",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Come scansionare i documenti?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Caricamento non riuscito",
						"too_large_file": "Il file è troppo grande <strong>(massimo {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Ti è permesso di caricare solo {number} file.",
						"invalid_file_format": "Formato di file non valido. I soli file accettati sono {acceptedFileFormats}",
						"duplicate_file_name": "Nome file duplicato. Tutti i file caricati devono avere nomi univoci.",
						"try_again": "Riprova o <u>scegli un altro file</u>"
					},
					"buttons": {
						"modal": "Perché ci servono i tuoi documenti?",
						"next": "Avanti",
						"back": "Indietro",
						"submit": "Invia documentazione"
					}
				},
				"document_upload_success": {
					"title": "Caricamento completo.",
					"message": "Grazie! I tuoi documenti sono stati caricato con successo."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Puoi inserire il codice fiscale aziendale?",
							"AT": "Puoi inserire il codice fiscale aziendale?",
							"CA": "Puoi inserire il tuo BN federale?",
							"GR": "Puoi inserire il tuo numero G.E.MI. (Γ.Ε.ΜΗ.)?",
							"NZ": "Puoi inserire il tuo numero dell’atività?"
						},
						"managed": {
							"default": "Puoi inserire il codice fiscale aziendale?",
							"AT": "Puoi inserire il codice fiscale aziendale?",
							"CA": "Puoi inserire il tuo BN federale?",
							"GR": "Puoi inserire il numero G.E.MI. (Γ.Ε.ΜΗ.) dell’azienda?",
							"NZ": "Puoi inserire il numero dell’attività dell’azienda?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
							"CA": "Abbiamo bisogno del tuo numero federale di azienda assegnato alla tua azienda dal CRA (Canada Revenue Agency) per verificare i dati della tua attività.",
							"GR": "Abbiamo bisogno del tuo numero G.E.MI. per verificare i dati dell'attività.",
							"NZ": "Abbiamo bisogno del numero della tua attività per verificare i dati dell’attività."
						},
						"managed": {
							"default": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività.",
							"CA": "Abbiamo bisogno del tuo numero federale di azienda assegnato alla tua azienda dal CRA (Canada Revenue Agency) per verificare i dati della tua attività.",
							"GR": "Abbiamo bisogno del numero G.E.MI. per verificare i dati dell'attività.",
							"NZ": "Abbiamo bisogno del numero dell’azienda per verificare i dati dell’attività."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Ti ricordiamo che al momento Klarna non può fornire i suoi servizi di pagamento alle imprese individuali canadesi. Procedendo con la tua richiesta, questa verrà respinta."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Codice fiscale aziendale",
								"AT": "Codice fiscale aziendale",
								"CA": "Numero dell’azienda",
								"GR": "Numero G.E.MI. (Γ.Ε.ΜΗ.)",
								"NZ": "Numero dell’azienda"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Qual è la tua classificazione fiscale?",
						"managed": "Puoi inserire la classificazione fiscale dell’azienda?"
					},
					"subtitle": {
						"unmanaged": "Ti chiederemo diverse informazioni a seconda dello stato giuridico dell’azienda.",
						"managed": "Ti chiederemo diverse informazioni a seconda dello stato giuridico dell’azienda."
					},
					"info": {
						"unmanaged": "Puoi trovare l’EIN (numero di identificazione del datore di lavoro) della tua azienda sulle dichiarazioni dei redditi, i rapporti di credito, i documenti del libro paga o le licenze e i permessi numero di identificazione del datore di ",
						"managed": "Puoi trovare l’EIN (numero di identificazione del datore di lavoro) dell’azienda sulle dichiarazioni dei redditi, i rapporti di credito, i documenti del libro paga o le licenze e i permessi."
					},
					"fields": {
						"registration_number": {
							"label": "Numero d’identificazione del datore di lavoro",
							"errors": {
								"general": "Inserisci un numero di identificazione del datore di lavoro valido",
								"invalid": "Il numero di identificazione del datore di lavoro deve essere di 9 cifre con un “-” dopo le prime due. Es: 12-3456789"
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Classificazione fiscale federale",
								"managed": "Tipo di attività"
							},
							"errors": {
								"is_one_of": "Si prega di scegliere uno dei tipi di attività elencati"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Puoi inserire il tuo numero di partita IVA?",
							"AU": "Puoi inserire il tuo ABN?",
							"ES": "Qual è il tuo numero di identificazione fiscale?",
							"NZ": "Puoi inserire il tuo numero GST?"
						},
						"managed": {
							"default": "Puoi inserire il numero di partita IVA?",
							"AU": "Puoi inserire l’ABN?",
							"ES": "Qual è il tuo numero di identificazione fiscale?",
							"NZ": "Puoi inserire il numero GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Con il numero di partita IVA possiamo verificare più facilmente i dati della tua azienda.",
							"AU": "Con il tuo ABN possiamo verificare più facilmente i dati della tua azienda.",
							"NZ": "Con il numero GST possiamo verificare più facilmente i dati della tua azienda.",
							"ES": "Con il numero NIF, NIE o DNI possiamo verificare più facilmente i dati della tua azienda."
						},
						"managed": {
							"default": "Usiamo il numero di partita IVA per verificare i dati dell’azienda.",
							"AU": "Usiamo l’ABN per verificare i dati dell’azienda.",
							"NZ": "Usiamo il numero GST per verificare i dati dell’azienda.",
							"ES": "Usiamo il numero NIF, NIE o DNI per verificare i dati dell’azienda."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "Numero partita IVA",
								"AU": "ABN",
								"NZ": "Numero GST",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Avanti",
						"back": "Indietro"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Che tipo di attività svolgi?",
						"managed": "Che tipo di attività svolge questa azienda?"
					},
					"subtitle": {
						"unmanaged": "Siamo tenuti a fare alcune domande specifiche in base al tipo di attività.",
						"managed": "Siamo tenuti a fare alcune domande specifiche in base al tipo di attività."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Tipo di entità legale",
							"errors": {
								"is_one_of": "Si prega di scegliere uno dei tipi di attività elencati"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "La tua azienda è una società registrata?",
							"AU": "La tua azienda ha un ACN?",
							"ES": "La tua azienda è iscritta al Registro Mercantil?"
						},
						"managed": {
							"default": "Questa azienda è una società registrata?",
							"AU": "Questa azienda ha un ACN?",
							"ES": "La tua azienda è iscritta al Registro Mercantil?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
							"AU": "Se sei in possesso di un ACN inseriscilo, altrimenti seleziona no e procedi.",
							"ES": "Rispondi Sì se sei un SL, SA, SCP, ecc. Rispondi no se sei un lavoratore autonomo, freelance, ecc.",
							"GB": "Abbiamo bisogno del numero di organizzazione della tua azienda per verificare i dati dell’attività.",
							"GR": "Abbiamo bisogno del tuo numero G.E.MI. per verificare i dati dell'attività."
						},
						"managed": {
							"default": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività.",
							"AU": "Se questa azienda è in possesso di un ACN inseriscilo, altrimenti seleziona no e procedi.",
							"ES": "Rispondi Sì se sei un SL, SA, SCP, ecc. Rispondi no se sei un lavoratore autonomo, freelance, ecc.",
							"GB": "Abbiamo bisogno del numero di organizzazione dell’azienda per verificare i dati dell’attività.",
							"GR": "Abbiamo bisogno del numero G.E.MI. per verificare i dati dell’attività."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Inserisci il codice fiscale aziendale",
							"AT": "Inserisci il codice fiscale aziendale ",
							"AU": "Inserisci l’ACN",
							"ES": "Inserisci il tuo NIF/NIE/DNI aziendale",
							"GB": "Inserisci il numero di organizzazione",
							"GR": "Inserisci il tuo numero G.E.MI. (Γ.Ε.ΜΗ.)"
						},
						"managed": {
							"default": "Inserisci il codice fiscale aziendale",
							"AT": "Inserisci il codice fiscale aziendale",
							"AU": "Inserisci l’ACN",
							"ES": "Inserisci il tuo NIF/NIE/DNI aziendale",
							"GB": "Inserisci il numero di organizzazione",
							"GR": "Inserisci il numero G.E.MI. (Γ.Ε.ΜΗ.)"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Codice fiscale aziendale",
								"AT": "Codice fiscale aziendale",
								"AU": "Australian Company Number (ACN)",
								"ES": "NIF/NIE/DNI aziendale",
								"GB": "Organizzazione numero",
								"GR": "Numero G.E.MI. (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Avanti",
						"back": "Indietro"
					}
				},
				"mid-selector": {
					"title": "Seleziona un negozio",
					"subtitle": "Questa email è associata a svariati negozi. Seleziona un negozio per continuare.",
					"mid-selector": "Merchant ID / Nome negozio",
					"buttons": {
						"next": "Continua"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "La tua azienda è una società registrata?",
						"managed": "Questa azienda è una società registrata?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale della tua azienda per verificare i dati dell’attività."
						},
						"managed": {
							"default": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività.",
							"AT": "Abbiamo bisogno del codice fiscale aziendale per verificare i dati dell’attività."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Inserisci il codice fiscale aziendale ",
							"AT": "Inserisci il codice fiscale aziendale "
						},
						"managed": {
							"default": "Inserisci il codice fiscale aziendale",
							"AT": "Inserisci il codice fiscale aziendale"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Codice fiscale aziendale",
								"AT": "Codice fiscale aziendale"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "La tua attività ha una partita IVA?",
							"ES": "La tua azienda ha un NIF/NIE/DNI?",
							"NZ": "La tua attività ha un GST?"
						},
						"managed": {
							"default": "Questa attività ha una partita IVA?",
							"ES": "La tua azienda ha un NIF/NIE/DNI?",
							"NZ": "Questa attività ha un GST?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Se hai una partita IVA possiamo verificare più facilmente i dati della tua azienda.",
							"ES": "Se la tua azienda ha un numero NIF/NIE/DNI possiamo verificarne più facilmente i dati.",
							"NZ": "Se hai numero GST possiamo verificare più facilmente i dati della tua azienda."
						},
						"managed": {
							"default": "Usiamo il numero di partita IVA per verificare i dati dell’azienda.",
							"ES": "Se la tua azienda ha un numero NIF/NIE/DNI possiamo verificarne più facilmente i dati.",
							"NZ": "Usiamo il numero GST per verificare i dati dell’azienda."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Inserisci il tuo numero di partita IVA",
							"ES": "Inserisci il tuo NIF/NIE/DNI aziendale",
							"NZ": "Inserisci il tuo numero GST"
						},
						"managed": {
							"default": "Inserisci il numero di partita IVA",
							"ES": "Inserisci il tuo NIF/NIE/DNI aziendale",
							"NZ": "Inserisci il tuo numero GST"
						}
					},
					"vat_id": {
						"label": {
							"default": "Numero partita IVA",
							"ES": "NIF/NIE/DNI aziendale",
							"NZ": "Numero GST"
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "La tua attività ha una partita IVA?",
						"managed": "Questa attività ha una partita IVA?"
					},
					"subtitle": {
						"unmanaged": "Se hai una partita IVA possiamo verificare più facilmente i dati della tua azienda.",
						"managed": "Usiamo il numero di partita IVA per verificare i dati dell’azienda."
					},
					"form_title": {
						"unmanaged": "Inserisci il tuo numero di partita IVA",
						"managed": "Inserisci il numero di partita IVA"
					},
					"vat_id": {
						"label": {
							"default": "Numero partita IVA",
							"NZ": "Numero GST"
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Qual è l’indirizzo della tua attività?",
						"managed": "Qual è l’indirizzo dell’azienda?"
					},
					"subtitle": {
						"unmanaged": "Abbiamo bisogno di sapere l’ubicazione della tua azienda.",
						"managed": "Abbiamo bisogno di sapere l’ubicazione dell’azienda."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"fields": {
						"partnership_name": {
							"label": "Nome della collaborazione",
							"errors": {
								"general": "Inserisci un nome della collaborazione"
							}
						},
						"street": {
							"label": "Via",
							"errors": {
								"general": "Inserisci una via valida"
							}
						},
						"postal_code": {
							"label": "Codice postale",
							"errors": {
								"general": "Inserisci un codice postale valido"
							}
						},
						"city": {
							"label": "Città",
							"errors": {
								"general": "Inserisci una città valida"
							}
						},
						"country": {
							"label": "Paese",
							"errors": {
								"general": "Inserisci un Paese valido"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Chi è il titolare dell’azienda?",
						"GB": "Chi gestisce l’azienda?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Siamo legalmente obbligati dalla direttiva antiriciclaggio dell’UE ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						],
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						]
					},
					"infobox": "Inserisci le informazioni personali e l’indirizzo di residenza di tutti i collaboratori e individui principali che esercitano il controllo sulla gestione dell’azienda.",
					"buttons": {
						"add_person": "+ Aggiungi persona",
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"payouts_summary": {
					"title": "Conti bancari",
					"default_bank_accounts": {
						"no_elements": "Nessun conto bancario predefinito disponibile"
					},
					"additional_bank_accounts": {
						"no_elements": "Non hai presentato alcun conto bancario aggiuntivo"
					}
				},
				"pre_assessment_company_details": {
					"title": "Inserisci più dettagli sull’opportunità.",
					"subtitle": "Ti preghiamo di fornirci la parte di volume di transazioni su carta e i dati dell’azienda per questo commerciante. Indica anche se l’azienda opera da un altro mercato che non sia nel Paese di registrazione poiché questa informazione è necessaria per la valutazione del rischio.",
					"fields": {
						"volume_by_card": {
							"label": "Parte di transazioni su carta del volume totale (%)",
							"errors": {
								"invalid": "Questo deve essere un valore compreso tra 0 e 100",
								"invalid_hint": "Aggiungi la parte di volume delle transazioni su carta dal volume totale di Klarna per questa opportunità. Inserisci 0% se la tua opportunità non offre pagamenti con carta"
							}
						},
						"average_order_value": {
							"label": "Valore medio dell’ordine",
							"tooltip": "Deve essere un importo positivo in SEK",
							"errors": {
								"invalid": "Deve essere un importo positivo in SEK"
							}
						},
						"registration_country": {
							"label": "Paese di registrazione",
							"errors": {
								"required": "Il Paese di registrazione è necessario"
							}
						},
						"operating_country": {
							"label": "Paese di operatività",
							"errors": {
								"required": "Il Paese di operatività è necessario"
							}
						},
						"registration_number": {
							"label": {
								"default": "Numero di registrazione (richiesto per le aziende registrate)",
								"AU": "ACN (richiesto per le aziende registrate)",
								"ES": "NIF-NIE/DNI aziendale (richiesto per le aziende registrate)",
								"GR": "Numero G.E.MI. (Γ.Ε.ΜΗ.) (richiesto per le aziende registrate)",
								"NZ": "Numero aziendale (richiesto per le aziende registrate)",
								"US": "TIN/EIN (richiesto per le aziende registrate)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Fornisci ACN o ABN",
								"invalid": "L’ABN deve essere di 11 cifre"
							}
						},
						"registration_authority": {
							"label": "Autorità di registrazione",
							"errors": {
								"required": "Seleziona la tua autorità di registrazione"
							}
						},
						"company_name": {
							"label": "Nome dell’entità legale",
							"errors": {
								"required": "Il nome dell’entità legale deve essere inserito"
							}
						},
						"sales_contact": {
							"label": "Email del rappresentante commerciale",
							"errors": {
								"invalid": "Inserisci una email valida"
							}
						},
						"store_url": {
							"label": "URL del negozio",
							"errors": {
								"required": "L’URL del negozio è necessario",
								"invalid": "Inserisci un URL valido del sito web"
							}
						},
						"goods_category": {
							"label": "Principale categoria merceologica venduta",
							"errors": {
								"invalid": "Devi selezionare una delle opzioni"
							}
						},
						"is_managed": {
							"label": "Pubblicare il post gestito?"
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"pre_assessment_products": {
					"title": "Elenca tutti gli articoli",
					"subtitle": "Per la valutazione del rischio sono richiesti tutti gli articoli per Paese di vendita",
					"select": {
						"label": "Cerca prodotto"
					},
					"selected": {
						"label": "Prodotti selezionati:"
					},
					"clear": "Elimina tutti",
					"errors": {
						"invalid": "Deve essere selezionato almeno un prodotto per Paese"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "In-store",
						"TELESALES": "Televendita",
						"SELLER_APP": "App del venditore"
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"wrong_prefill_data": {
					"title": "Dati forniti non validi",
					"subtitle": "Informazioni di riempimento fornite da SalesForce non valide o incompatibili.",
					"details": "Dati: ",
					"fields": {
						"goodsCategory": "Categoria merceologica",
						"paymentInterval": "Intervallo di pagamento",
						"paymentDelay": "Ritardo nel pagamento",
						"registrationCountry": "Paese di registrazione",
						"storeUrl": "URL del negozio",
						"mainSellingCountry": "Principale Paese di vendita",
						"products": "Prodotti",
						"products_item": "Prodotto {index}",
						"products_item_yearlyAcquiredVolume": "Volume annuo acquisito del prodotto {index}",
						"products_item_sellingCountry": "Paese di vendita del prodotto {index}",
						"products_item_productName": "Nome del prodotto {index}",
						"products_item_channels": "Canali del prodotto {index}",
						"products_item_channels_item": "Canale del prodotto {index}"
					},
					"error_types": {
						"fallback": "non è valido",
						"any": {
							"required": "è richiesto e non ne è stato fornito nessuno"
						}
					}
				},
				"selling_countries": {
					"title": "Elenca tutti i paesi di vendita",
					"subtitle": "La lista completa dei paesi è richiesta per la valutazione del rischio",
					"select": {
						"label": "Cerca Paese"
					},
					"selected": {
						"label": "Paesi selezionati:"
					},
					"fields": {
						"selling_countries": {
							"label": "Seleziona Paese",
							"errors": {
								"invalid": "Devi selezionare almeno un Paese"
							}
						}
					},
					"clear": "Elimina tutti",
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"main_selling_country": {
					"title": "Qual è il mercato principale Klarna per il commerciante?",
					"subtitle": "Seleziona il mercato con il volume Klarna previsto più elevato",
					"errors": {
						"invalid": "Devi selezionare un Paese"
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"fca_number": {
					"title": "Inserisci il numero FCA",
					"subtitle": "Siamo tenuti per legge a verificare la licenza del mediatore di credito.",
					"fields": {
						"fca_number": {
							"label": "Numero FCA",
							"errors": {
								"general": "Inserisci un numero FCA valido"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"sole_trader": {
					"title": "Chi è il titolare dell’azienda?",
					"subtitle": {
						"default": [
							{
								"text": "Siamo legalmente obbligati dalla direttiva antiriciclaggio dell’UE ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						]
					},
					"infobox": {
						"unmanaged": "Inserisci le tue informazioni personali e il tuo indirizzo di residenza.",
						"managed": "Inserisci le informazioni personali del proprietario e il suo indirizzo di residenza."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "La persona che sta effettuando la richiesta è la stessa dell’impresa individuale",
							"error": "Spiacenti, ma puoi procedere solo se sei tu come impresa individuale a presentare questa domanda."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Operi da un indirizzo differente?",
								"managed": "Questa azienda opera da un indirizzo differente?"
							},
							"subtitle": {
								"unmanaged": "Seleziona Sì solamente se il tuo business opera da un altro indirizzo che non sia la tua residenza.",
								"managed": "Seleziona Sì solamente se l’attività di questa azienda opera da un altro indirizzo che non sia la residenza dell’imprenditore individuale."
							}
						},
						"title": "Fornisci l’indirizzo del business",
						"fields": {
							"street": {
								"label": "Via",
								"errors": {
									"general": "Fornisci una via valida"
								}
							},
							"postal_code": {
								"label": "Codice postale",
								"errors": {
									"general": "Fornisci un codice postale valido"
								}
							},
							"city": {
								"label": "Città",
								"errors": {
									"general": "Fornisci una città valida"
								}
							},
							"country": {
								"label": "Paese",
								"errors": {
									"general": "Fornisci un Paese valido"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Puoi confermare un paio di cose?",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Sei un commerciante individuale",
							"label": "La persona che sta effettuando la richiesta è la stessa dell’impresa individuale"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Sei l’unico ad avere il controllo finanziario",
							"label": "Il titolare è l’unica persona che ha il controllo finanziario sui conti bancari della sua azienda"
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"robot_message": "Spiacenti, ma ci devi confermare queste due cose"
				},
				"underwriting_info": {
					"title": "Specifica il volume e il termine di pagamento dell’opportunità",
					"subtitle": "Elenca il volume annuo complessivo previsto per Klarna per questa opportunità per tutti i mercati e il ritardo di pagamento. Nel caso in cui il ritardo di pagamento differisca per Paese, usa quello per il Paese principale di vendita selezionato.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Volume totale annuo del mercato (in SEK)",
							"errors": {
								"invalid": "Il volume totale annuo del mercato deve essere un importo positivo espresso in SEK",
								"too_long": "Il volume totale annuo del mercato non può avere più di 16 cifre."
							}
						},
						"payment_delay": {
							"label": "Ritardo nel pagamento",
							"errors": {
								"general": "Fornisci un valore per il ritardo di pagamento",
								"invalid": "Il ritardo di pagamento deve essere un numero compreso tra {min} e {max}"
							}
						},
						"payment_interval": {
							"label": "Intervallo di pagamento",
							"errors": {
								"invalid": "Devi selezionare una delle opzioni"
							}
						},
						"volume_by_card": {
							"label": "Quota di cassa (%)",
							"errors": {
								"invalid": "La quota di cassa deve essere un numero compreso tra 0 e 100.",
								"invalid_hint": "Aggiungi la parte di volume delle transazioni su carta dal volume totale di Klarna per questa opportunità. Inserisci 0% se la tua opportunità non offre pagamenti con carta"
							}
						},
						"average_order_value": {
							"label": "Valore medio dell’ordine (in SEK)"
						}
					},
					"buttons": {
						"back": "Indietro",
						"next": "Prossimo"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Quali sono i dati del tuo negozio?"
						},
						"managed": "Quali sono i dati del negozio?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Useremo le informazioni per impostare il tuo account commerciale.",
							"default": "Useremo i dettagli forniti come informazioni di contatto principali e per dare un’occhiata al tuo negozio."
						},
						"managed": "Useremo i dettagli forniti come informazioni di contatto principali per i clienti e per dare un’occhiata al tuo negozio."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Nome del brand/ DBA",
								"MX": "Nome del brand/ DBA",
								"US": "Nome del brand/ DBA",
								"default": "Nome negozio"
							},
							"errors": {
								"required": "Il nome del negozio è necessario",
								"required_us": "Nome del brand/ DBA è richiesto",
								"invalid": "Inserisci il nome del negozio, composto da almeno 2 caratteri",
								"invalid_us": "Inserisci il nome del brand/DBA, composto da almeno 2 caratteri",
								"invalid_characters": "Il nome del negozio non può contenere i seguenti caratteri: < >",
								"invalid_characters_us": "Il nome del brand / DBA non può contenere i seguenti caratteri: < >"
							}
						},
						"website": {
							"label": "Sito web del negozio online",
							"errors": {
								"required": "Il sito web è richiesto",
								"invalid": "Inserisci un URL valido del sito web"
							}
						},
						"goods_category": {
							"label": "Principale categoria merceologica venduta",
							"errors": {
								"required": "La categoria merceologica è richiesta"
							}
						},
						"email": {
							"label": "Email Supporto clienti",
							"errors": {
								"required": "L’email per il supporto clienti è richiesta",
								"invalid": "Inserisci una email valida"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Cambia prodotti"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Qual è l'indirizzo della sede legale?",
						"managed": "Qual è l’indirizzo commerciale registrato della società?"
					},
					"subtitle": {
						"unmanaged": "Abbiamo bisogno di sapere a quale indirizzo è registrata la tua attività.",
						"managed": "Abbiamo bisogno di conoscere qual è la sede legale dell’attività."
					},
					"question": {
						"title": {
							"unmanaged": "Operi da un indirizzo differente?",
							"managed": "Questa azienda opera da un indirizzo differente?"
						},
						"subtitle": {
							"unmanaged": "Seleziona Sì solamente se il tuo business opera da un altro indirizzo che non sia l’indirizzo della sede legale.",
							"managed": "Seleziona Sì solamente se l’attività di questa azienda opera da un altro indirizzo che non sia l’indirizzo commerciale registrato."
						}
					},
					"toggle": {
						"title": "Aggiungi l’indirizzo della sede principale dell’attività"
					},
					"fields": {
						"company_name": {
							"label": "Nome legale dell’azienda",
							"errors": {
								"general": "Fornisci una ragione sociale"
							}
						},
						"street": {
							"label": "Indirizzo",
							"errors": {
								"general": "Fornisci una via"
							}
						},
						"postal_code": {
							"label": "Codice postale",
							"errors": {
								"general": "Fornisci un codice postale"
							}
						},
						"city": {
							"label": "Città",
							"errors": {
								"general": "Fornisci una città"
							}
						},
						"country": {
							"label": "Paese",
							"errors": {
								"general": "Fornisci un Paese"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"messages": {
						"lookup": "Questa è la tua azienda? Dai un’occhiata e conferma la correttezza delle informazioni."
					}
				},
				"uk_sole_trader": {
					"title": "Chi è il titolare di questa azienda?",
					"subtitle": {
						"unmanaged": "Stai per stipulare un contratto con Klarna. Perciò, abbiamo bisogno di raccogliere le tue informazioni personali.",
						"managed": "Siamo tenuti a raccogliere e verificare le informazioni personali del proprietario."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Operi da un indirizzo differente?",
								"managed": "Questa azienda opera da un indirizzo differente?"
							},
							"subtitle": {
								"unmanaged": "Seleziona Sì solamente se il tuo business opera da un altro indirizzo che non sia la tua residenza.",
								"managed": "Seleziona Sì solamente se l’attività di questa azienda opera da un altro indirizzo che non sia la residenza dell’imprenditore individuale."
							}
						},
						"title": "Fornisci l’indirizzo del business",
						"fields": {
							"street": {
								"label": "Via",
								"errors": {
									"general": "Fornisci una via valida"
								}
							},
							"postal_code": {
								"label": "Codice postale",
								"errors": {
									"general": "Fornisci un codice postale valido"
								}
							},
							"city": {
								"label": "Città",
								"errors": {
									"general": "Fornisci una città valida"
								}
							},
							"country": {
								"label": "Paese",
								"errors": {
									"general": "Fornisci un Paese valido"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Chi è il titolare dell’azienda?",
					"subtitle": {
						"default": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
					},
					"infobox": {
						"unmanaged": "Inserisci le tue informazioni personali e il tuo indirizzo di residenza.",
						"managed": "Inserisci le informazioni personali del proprietario e il suo indirizzo di residenza."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Operi da un indirizzo differente?",
								"managed": "Questa azienda opera da un indirizzo differente?"
							},
							"subtitle": {
								"unmanaged": "Seleziona Sì solamente se il tuo business opera da un altro indirizzo che non sia la tua residenza.",
								"managed": "Seleziona Sì solamente se l’attività di questa azienda opera da un altro indirizzo che non sia la residenza dell’imprenditore individuale."
							}
						},
						"title": "Fornisci l’indirizzo del business",
						"fields": {
							"street": {
								"label": "Via",
								"errors": {
									"general": "Fornisci una via valida"
								}
							},
							"postal_code": {
								"label": "Codice postale",
								"errors": {
									"general": "Fornisci un codice postale valido"
								}
							},
							"city": {
								"label": "Città",
								"errors": {
									"general": "Fornisci una città valida"
								}
							},
							"country": {
								"label": "Paese",
								"errors": {
									"general": "Fornisci un Paese valido"
								}
							},
							"region": {
								"label": "Stato",
								"errors": {
									"general": "Fornisci uno stato"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Ci sono persone che possiedono più del 25% dell’azienda?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"default": [
							{
								"text": "Abbiamo bisogno di conoscere le persone che possiedono più del 25% delle azioni o dei diritti di voto dell’azienda o che esercitano un controllo simile. Siamo legalmente obbligati dalla direttiva UE contro il riciclaggio di denaro ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						]
					},
					"infobox": {
						"default": "Inserisci le informazioni personali di ciascun individuo e il suo indirizzo di residenza.",
						"AU": "Inserisci le informazioni personali di ciascun individuo e il suo indirizzo di residenza. Queste devono essere persone fisiche per le aziende con strutture proprietarie complesse."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro",
						"add_person": "+ Aggiungi persona"
					},
					"messages": {
						"lookup": "Queste persone possiedono più del 25% della tua azienda? Dai un’occhiata e conferma la correttezza delle informazioni."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Qual è l’indirizzo della tua attività?",
						"managed": "Qual è l’indirizzo commerciale registrato della società?"
					},
					"subtitle": {
						"unmanaged": "Questo è il luogo in cui la tua azienda è legalmente registrata e apparirà sulle fatture dei tuoi clienti Klarna.",
						"managed": "Abbiamo bisogno di conoscere qual è la sede legale dell’attività."
					},
					"question": {
						"title": {
							"unmanaged": "Operi da un indirizzo differente?",
							"managed": "Questa azienda opera da un indirizzo differente?"
						},
						"subtitle": {
							"unmanaged": "Seleziona Sì solamente se il tuo business opera da un altro indirizzo che non sia l’indirizzo commerciale registrato.",
							"managed": "Seleziona Sì solamente se l’attività di questa azienda opera da un altro indirizzo che non sia l’indirizzo commerciale registrato."
						}
					},
					"toggle": {
						"title": "Aggiungi l’indirizzo della sede principale dell’attività"
					},
					"fields": {
						"company_name": {
							"label": "Nome dell’azienda registrata",
							"errors": {
								"general": "Fornisci una ragione sociale"
							}
						},
						"street": {
							"label": "Indirizzo",
							"errors": {
								"general": "Fornisci una via"
							}
						},
						"postal_code": {
							"label": "Codice postale",
							"errors": {
								"general": "Fornisci un codice postale"
							}
						},
						"city": {
							"label": "Città",
							"errors": {
								"general": "Fornisci una città"
							}
						},
						"country": {
							"label": "Paese",
							"errors": {
								"general": "Fornisci un Paese"
							}
						},
						"state_of_incorporation": {
							"label": "Stato di costituzione",
							"errors": {
								"general": "Fornisci uno stato di costituzione"
							}
						},
						"state": {
							"label": "Stato",
							"errors": {
								"general": "Fornisci uno stato"
							}
						},
						"region": {
							"label": "Regione",
							"errors": {
								"puerto_rico": "Porto Rico non è consentito"
							}
						}
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"select_products": {
					"title": "I nostri servizi",
					"title_kco_hidden": "Metodi di pagamento che aumentano le vendite.",
					"subtitle": "Seleziona i servizi che ti interessano.",
					"subtitle_kco_hidden": "Sblocca il potere d’acquisto dei tuoi clienti. Offri più opzioni di pagamento in modo che possano decidere quando e come pagare.",
					"platform_alert": null,
					"buttons": {
						"next": "Prossimo"
					}
				},
				"signup_products": {
					"title_line_1": "Scegli i tuoi prodotti Klarna.",
					"title_kco_hidden_line_1": "Metodi di pagamento che",
					"title_kco_hidden_line_2": "aumentano le vendite.",
					"subtitle": "Questi sono i metodi di pagamento che potrai offrire ai tuoi clienti.",
					"subtitle_kco_hidden": "Sblocca il potere d’acquisto dei tuoi clienti. Offri più opzioni di pagamento in modo che possano decidere quando e come pagare.",
					"info_block": "Visualizzazione dei prodotti disponibili per",
					"special_offer": "Offerta speciale: {percentageFee}% + {fixedFee} per transazione. Valida fino al giorno {validUntil}.",
					"buttons": {
						"contact_sales": "Contatta il reparto vendite",
						"next": "Crea account",
						"back": "Indietro"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Indietro",
						"next": "Prossimo"
					}
				},
				"business_concepts": {
					"title": "Seleziona i concetti di business applicabili.",
					"subtitle": "Seleziona solo quelli applicabili. Questi possono essere più di uno.",
					"errors": {
						"select_at_least_one": "Seleziona almeno in concetto di business."
					},
					"buttons": {
						"next": "Prossimo",
						"back": "Indietro"
					}
				},
				"confirm_copy": {
					"title": "Conferma la copia",
					"disclaimer": "Qualsiasi informazione esistente nel MID corrente sarà sovrascritta con i dati di",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Non copiare",
						"confirmCopy": "Copia dati"
					}
				},
				"pre_assessment_summary": {
					"title": "Riepilogo",
					"subtitle": "Rivedi attentamente i dati prima di presentarli per la sottoscrizione",
					"banner": {
						"mcc_deal": "Questo è un accordo MCC, segui la routine di risoluzione MCC / ECC"
					},
					"selling_countries": {
						"title": "Seleziona il mercato con il volume previsto più elevato.",
						"main_selling_country": "Principale Paese di vendita"
					},
					"pre_assessment_products": {
						"title": "Prodotti"
					},
					"company_details": {
						"title": "Dati dell’azienda"
					},
					"fca_number": {
						"title": "Numero FCA"
					},
					"high_exposure_questionnaires": {
						"title": "Questionari ad alta esposizione"
					},
					"mia_questionnaires": {
						"title": "Questionari MIA"
					},
					"buttons": {
						"back": "Indietro",
						"edit": "Modifica",
						"submit": "Invia"
					}
				},
				"pre_assessment_overview": {
					"title": "Panoramica di prevalutazione",
					"subtitle_APPROVED": "Qui sotto troverai le condizioni approvate per questa opportunità.",
					"subtitle_REJECTED": "Qui sotto troverai le condizioni respinte per questa opportunità.",
					"subtitle_UNRESOLVED": "Puoi cambiare le informazioni inviate nel caso in cui riscontri degli errori. Questo non fa partire un nuovo caso.",
					"status": {
						"APPROVED": "Il caso è stato approvato",
						"REJECTED": "Il caso è stato rifiutato",
						"UNRESOLVED": "In attesa della decisione di sottoscrizione…",
						"UNRESOLVED_TIMED_OUT": "Il caso passerà attraverso la sottoscrizione manuale. Tieni presente che questo può richiedere più giorni.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Visualizza il caso nella GUI Merchant Review",
						"STARTED": "Il caso è sottoposto a revisione"
					},
					"buttons": {
						"change": "Modifica",
						"new_case": "Nuovo caso"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Buongiorno!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Essendo un’azienda regolamentata sotto la supervisione dell’Autorità di vigilanza finanziaria svedese, Klarna è tenuta a prevenire il riciclaggio di denaro come stabilito dalla direttiva UE 2015/849 (e successive modifiche o sostituzioni periodiche). Per te in qualità di commerciante, la direttiva significa che Klarna raccoglierà informazioni sulle persone che controllano la tua azienda (titolari effettivi) prima che tu possa iniziare a utilizzare i servizi di Klarna. I commercianti esistenti devono fornire su base periodica tali informazioni per garantire che siano aggiornate. Puoi trovare maggiori informazioni nella direttiva UE "
							},
							{
								"text": "qui",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": "."
							}
						]
					},
					"buttons": {
						"next": "Prossimo"
					}
				},
				"recollection_confirmation": {
					"title": "Conferma",
					"subtitle": "Rivedi attentamente i dati prima di presentarli per la sottoscrizione",
					"stakeholder": "Parti interessate {index}",
					"buttons": {
						"back": "Indietro",
						"submit": "Invia"
					}
				},
				"recollection_overview": {
					"title": "Grazie!",
					"subtitle": "Ecco una panoramica delle informazioni che hai presentato.",
					"stakeholder": "Parti interessate {index}",
					"notice": "Le tue informazioni sono state inviate con successo."
				},
				"volume_separation": {
					"title_line_1": "Quali sono le dimensioni della tua attività online?",
					"subtitle": "Klarna è dotata delle migliori soluzioni più adatte alla tua attività, indipendentemente dalle sue dimensioni.",
					"selector_title": "Fatturato annuale",
					"below": "Al di sotto di {threshold}",
					"between": "Entro {belowThreshold} e {aboveThreshold}",
					"over": "Oltre {threshold}",
					"buttons": {
						"back": "Indietro"
					}
				},
				"basic_info": {
					"title_line_1": "Fai volare la tua azienda",
					"title_line_2": "con Klarna!",
					"subtitle": "Abbiamo bisogno di alcune informazioni di base per portarti nel posto giusto.",
					"fields": {
						"email": {
							"label": "Email aziendale",
							"field_link": "Non sei un’azienda?",
							"errors": {
								"required": "L’indirizzo email è necessario",
								"invalid": "Inserisci un indirizzo email valido"
							}
						},
						"email_confirmation": {
							"label": "Conferma email aziendale",
							"tooltip": "La tua email aziendale sarà il principale mezzo di comunicazione con Klarna. Assicurati di averla scritta correttamente",
							"errors": {
								"required": "È richiesta la conferma del tuo indirizzo email",
								"invalid": "Assicurati di aver inserito lo stesso indirizzo email due volte"
							}
						},
						"website": {
							"label": "URL e-commerce",
							"errors": {
								"required": "L’URL dell’e-commerce è necessario",
								"invalid": "Inserisci un URL valido"
							}
						},
						"country": {
							"label": "Paese di registrazione",
							"errors": {
								"general": "Seleziona uno dei paesi disponibili"
							}
						}
					},
					"buttons": {
						"continue": "Continua"
					}
				},
				"contact_details": {
					"title_line_1": "Facciamo due chiacchiere.",
					"subtitle": "Compila questo modulo e ti contatteremo al più presto con soluzioni su misura per la tua attività.",
					"fields": {
						"full_name": {
							"label": "Nome completo",
							"errors": {
								"required": "È necessario il nome completo"
							}
						},
						"phone": {
							"label": "Numero di telefono",
							"tooltip": "Devi includere il codice del Paese, per es. +1 541 754 3010",
							"errors": {
								"required": "Il numero di telefono è obbligatorio",
								"invalid": "Numero di telefono non valido"
							}
						},
						"tell_us_more": {
							"label": "Dicci un po’ di più sulla tua attività (opzionale)"
						}
					},
					"buttons": {
						"back": "Indietro",
						"submit": "Invia i tuoi dati di contatto"
					}
				},
				"contact_received": {
					"title": "Ci sentiamo presto!",
					"message_1": "Il nostro team di vendite si metterà in contatto con te al più presto.",
					"message_2": "Il nostro team ti contatterà al più presto. Abbiamo anche inviato una conferma dell’invio delle tue informazioni a "
				},
				"we_are_sorry": {
					"title": "Purtroppo al momento non possiamo accettare la tua richiesta.",
					"message_1_unsupported_country": "Al momento Klarna non supporta il Paese che hai selezionato:",
					"message_1_sensitive_goods": "Klarna non supporta le seguenti categorie merceologiche:",
					"message_1_platform": "Al momento Klarna non supporta la piattaforma e-commerce selezionata:",
					"message_2": "Cerchiamo continuamente di creare nuove partnership. Ti contatteremo non appena potrai continuare la tua richiesta in futuro",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Puoi sempre usare il"
							},
							{
								"text": "plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "del nostro partner Mollie."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Quale piattaforma stai utilizzando?",
					"subtitle": "Seleziona la tua piattaforma e-commerce per poter integrare Klarna al tuo store.",
					"custom": "Integrazione propria",
					"other_platform": "Altre soluzioni di integrazione",
					"platform_search": {
						"label": "Piattaforma e-commerce",
						"no_match": "Nessuna corrispondenza per \"{input}\""
					},
					"buttons": {
						"back": "Indietro"
					}
				},
				"partner": {
					"title_line_1": "Con quale partner di servizi di pagamento vorresti collaborare?",
					"subtitle": "Scegli il partner per i servizi di pagamento che meglio si adatta alle tue necessità."
				},
				"account_creation_loading": {
					"title": "Creazione del tuo account…",
					"message": "Impostazione dell’ID del tuo business in corso…"
				},
				"application_checking": {
					"title": "Verifica della tua richiesta in corso…",
					"message": "Analisi dei dati del negozio in corso"
				},
				"application_review": {
					"title": "Stiamo verificando la tua richiesta.",
					"title_approved": "La tua richiesta è stata approvata!",
					"message": "Questo è un processo manuale, quindi i tempi di elaborazione potrebbero variare, ma lo faremo il più velocemente possibile.",
					"email_info_1": "Ti abbiamo inviato una mail con oggetto “{subject}”.",
					"email_info_2": "Segui i passaggi indicati nella mail per accedere al Portale Commercianti e tracciare lo stato della tua richiesta.",
					"email_info_2_approved": "Segui i passi indicati nel messaggio per accedere e integrare Klarna nell’e-commerce del tuo negozio.",
					"email_subject": "Welcome to Klarna's Merchant Portal",
					"resend_email": "Invia di nuovo l’email"
				},
				"user_already_exists": {
					"title": "Accedi al Portale Merchant per continuare.",
					"message_1": "Questo indirizzo email è già associato a un account su Portale Merchant. Accedi per effettuare modifiche al tuo account esistente",
					"log_in": "Accedi al Portale Merchant",
					"forgot_password": "Hai dimenticato la password?"
				},
				"otherPlatform": {
					"info": "Abbiamo già l’integrazione per {platform}",
					"link": "Comincia qui con l’integrazione",
					"title": "Smoooth, puoi integrarti direttamente!",
					"info2": "Buone notizie! Puoi integrare Klarna al tuo e‑commerce direttamente da <strong>{platform}</strong>.",
					"link2": "Vai su {platform} + Klarna Integration"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Mettiti in contatto direttamente con il nostro team di vendita.",
							"SE": "Contatta direttamente il nostro team di vendita su"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Fornisci uno qualsiasi dei seguenti articoli o servizi?",
					"subtitle_2": "Klarna potrebbe definire alcuni articoli come ristrette in base al mercato, alle leggi, al volume delle vendite, alla propensione al rischio e ad altre limitazioni che possono essere consentite e non devono essere elaborate senza l'approvazione di Klarna.",
					"titleV2": "Scegli in quale delle seguenti categorie rientra la tua attività.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Articoli con limiti di età",
							"description_2": "Tabacco, sigarette elettroniche, vape, articoli a base di cannabis, alcool, contenuti per adulti"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Viaggi, tour ed eventi",
							"description_2": "Trasporti, eventi, piattaforme di biglietteria, hotel o alloggi, noleggi, agenzie turistiche"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Armi su licenza",
							"description_2": "Munizioni, coltelli da combattimento, attrezzatura da caccia, manganelli, spray al peperoncino"
						},
						"MARKETPLACE": {
							"title_2": "Marketplace",
							"description_2": "Servizi che consentono a terze parti di rivendere i propri articoli o di offrire servizi attraverso la propria piattaforma online"
						},
						"PHARMACEUTICALS": {
							"title_2": "Servizi medici e farmaceutici",
							"description_2": "Distribuzione di farmaci con ricetta, procedure mediche incluse quelle estetiche e tatuaggi"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Sottoscrizioni, abbonamenti e servizi",
							"description_2": "Abbonamento su beni fisici, contenuti digitali, servizi di streaming, siti di incontri, ecc."
						},
						"NONE": {
							"title_2": "Offro un tipo di articolo/servizio diverso"
						}
					},
					"link": "Ulteriori informazioni sugli articoli ristretti",
					"buttons": {
						"next": "Prossimo",
						"continue": "Continua"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Inserisci il tuo codice postale per riempire automaticamente gli altri campi del tuo indirizzo",
						"US": "Inserisci il tuo codice postale per riempire automaticamente gli altri campi del tuo indirizzo"
					},
					"label": {
						"default": "Codice postale",
						"US": "Codice postale"
					},
					"error": {
						"default": "Inserisci un codice postale valido",
						"US": "Inserisci un codice postale valido"
					}
				},
				"city": {
					"label": "Città",
					"error": "Inserisci una città"
				},
				"street": {
					"label": "Via",
					"error": "Inserisci una via",
					"tooltip": "Inizia a digitare per visualizzare ulteriori suggerimenti sul nome della via",
					"no_suggestion_found": "Nessuna corrispondenza per {input}"
				},
				"country": {
					"label": "Paese",
					"error": "Seleziona un Paese"
				},
				"region": {
					"label": "Stato/regione (opzionale)"
				},
				"state": {
					"label": "Stato",
					"error": "Inserisci uno stato"
				}
			},
			"platforms": {
				"custom": "Integrazione API",
				"other": "Non posso trovare la mia piattaforma"
			},
			"buttons": {
				"back": "Indietro"
			},
			"products": {
				"not_available": "Non disponibile su {reason}",
				"not_available_country": "Non disponibile nel tuo paese",
				"not_available_platform": "Non disponibile su {platform}",
				"why_product": "Perché Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Sostituisci il checkout del tuo negozio con i servizi checkout completi di Klarna."
					},
					"description_expanded": {
						"default": "Sostituisci il checkout del tuo negozio con i servizi checkout completi di Klarna."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Paga ora"
							},
							"description": {
								"default": "Offri pagamenti istantanei tramite bonifico bancario."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "Paga in 30 giorni"
							},
							"description": {
								"default": "Offri 30 giorni per pagare. Zero interessi."
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Finanziamento"
							},
							"description": {
								"default": "Offri di pagare in 6‑36 mesi.",
								"DE": "Offri di pagare in 6‑24 mesi",
								"AT": "Offri di pagare in 6‑24 mesi."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Paga in 3 rate"
							},
							"description": {
								"default": "Offri 3 rate senza interessi.",
								"GB": "Offri 3 rate senza interessi."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Dilaziona in 4",
								"US": "Paga in 3 rate",
								"AU": "Paga in 4 rate"
							},
							"description": {
								"default": "Offri 4 rate senza interessi.",
								"GB": "Offri 4 rate senza interessi."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Altre opzioni di pagamento"
							},
							"description": {
								"default": "Carte di credito, carte di debito e altro"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "On-site messaging"
							}
						},
						"billing": {
							"name": {
								"default": "Identificazione automatica e fatturazione"
							}
						},
						"shipping": {
							"name": {
								"default": "Opzioni di spedizione personalizzate"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Supporto post-vendita"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Metodo di pagamento"
					},
					"description": {
						"default": "Aggiungi i metodi di pagamento Klarna al tuo checkout"
					},
					"description_expanded": {
						"default": "L’offerta dei metodi di pagamento Klarna determina un aumento medio del tasso conversione pari al 30%, del 41% dell’AOV e del 36% della frequenza di acquisto."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Paga ora"
							},
							"description": {
								"default": "Offri pagamenti istantanei tramite bonifico bancario."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "Paga in 30 giorni"
							},
							"description": {
								"default": "I clienti pagano 30 giorni dopo l’acquisto, senza interessi."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Finanziamento"
							},
							"description": {
								"default": "I clienti possono pagare in 6-36 mesi.",
								"DE": "I clienti possono pagare in 6-24 mesi",
								"AT": "I clienti possono pagare in 6-24 mesi."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Paga in 3 rate"
							},
							"description": {
								"default": "Offri 3 rate senza interessi.",
								"GB": "Offri 3 rate senza interessi."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Dilaziona in 4",
								"US": "4 pagamenti",
								"CA": "4 pagamenti",
								"AU": "Paga in 4 rate"
							},
							"description": {
								"default": "Offri 4 rate senza interessi.",
								"GB": "Offri 4 rate senza interessi.",
								"US": "Gli ordini da 35 a 1.000 USD possono essere dilazionati in 4 rate senza interessi, con scadenza bisettimanale.",
								"CA": "Gli ordini da 35 a 1.000 USD possono essere dilazionati in 4 rate senza interessi, con scadenza bisettimanale."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Paga con carta"
							},
							"description": {
								"default": "Offri pagamenti istantanei tramite bonifico bancario."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Come hai in programma di effettuare le tue vendite?",
					"options": {
						"IN_STORE": "Negozio fisico",
						"TELESALES": "Vendite remote"
					},
					"description": {
						"IN_STORE": "Le vendite sono principalmente effettuate di persona e il cliente ottiene la merce direttamente.",
						"TELESALES": "Le vendite sono principalmente effettuate per telefono grazie alle chiamate ricevute dai clienti. Il cliente non ottiene subito la merce."
					}
				},
				"country": {
					"label": "Paese"
				},
				"organization_category": {
					"label": "Tipo di entità legale",
					"options": {
						"SOLE_TRADER": "Impresa individuale",
						"PARTNERSHIP": "Partnership",
						"UNDEFINED": "UNDEFINED",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C corporation",
						"S_CORP": "S corporation",
						"TRUST_ESTATE": "Fondo fiduciario/immobiliare",
						"INDIVIDUAL": "Individuo",
						"SOLE_PROPRIETORSHIP": "Azienda individuale",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "LLC a socio unico",
						"LIMITED_LIABILITY_COMPANY": "Società a responsabilità limitata",
						"PUBLIC_LISTED_COMPANY": "Società quotata in borsa",
						"PRIVATE_COMPANY": "AZIENDA_PRIVATA"
					}
				},
				"store_category": {
					"label": "Principale categoria merceologica venduta",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento da adulti",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Prodotti automobilistici - Parti e accessori per autoveicoli",
						"BAGS_AND_WALLETS": "Gioielli e accessori - Borse e portafogli",
						"BODY_AND_HAIR_CARE": "Salute e bellezza - Cura del corpo e dei capelli",
						"BOOK_AND_MAGAZINES": "Tempo libero - Libri e riviste",
						"CANDY": "Cibo e bevande - Dolciumi",
						"CAR_ELECTRONICS": "Elettronica - Elettronica per auto",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Articoli per bambini - Abbigliamento da bambini e prodotti per la nutrizione",
						"CHILDREN_TOYS": "Articoli per bambini - Giocattoli per bambini",
						"CLEANING_AND_SANITARY": "Casa e giardino - Pulizia e igiene",
						"COLLECTIBLES": "Tempo libero, sport e hobby - Collezionismo",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Tempo libero, sport e hobby - Negozi concept e articoli vari",
						"COSMETICS": "Salute e bellezza - Cosmetici",
						"COSTUMES_AND_PARTY_SUPPLIES": "Tempo libero, sport e hobby - Costumi e materiale per feste",
						"DATING_SERVICES": "Prodotti immateriali - Servizi di incontri",
						"DECORATION_AND_ART": "Casa e giardino - Decorazione e arte",
						"DIETARY_SUPPLEMENTS": "Salute e bellezza - Integratori alimentari",
						"DIGITAL_SERVICES": "Prodotti immateriali - Servizi digitali",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Articoli per bambini - Articoli vari per bambini",
						"DIVERSIFIED_ELECTRONICS": "Elettronica - Articoli elettronici vari",
						"DIVERSIFIED_ENTERTAINMENT": "Tempo libero - Intrattenimento diversificato",
						"DIVERSIFIED_EROTIC_MATERIAL": "Materiale erotico - Materiale erotico vario",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Salute e bellezza - Articoli vari per salute e bellezza",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Casa e giardino - Articoli vari per casa e giardino",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Gioielli e accessori - Gioielli e accessori vari",
						"EDUCATION": "Prodotti immateriali - Educazione",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elettronica - Apparecchiature elettroniche e relativi accessori",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Materiale erotico - Abbigliamento erotico e accessori",
						"EVENT_TICKETS": "Prodotti immateriali - Biglietti di eventi",
						"FOOD_AND_BEVERAGE": "Cibo e bevande - Cibo e bevande",
						"FRAGRANCES": "Salute e bellezza - Fragranze",
						"FURNITURE": "Casa e giardino - Mobili",
						"GENERAL_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento generico",
						"HOBBY_ARTICLES": "Tempo libero, sport e hobby - Articoli per hobby",
						"HOUSEHOLD_ELECTRONICS": "Elettronica - Elettronica per la casa",
						"JEWELRY_AND_WATCHES": "Gioielli e accessori - Gioielli e orologi",
						"KITCHENWARE": "Casa e giardino - Articoli da cucina",
						"MARKETPLACES": "Prodotti immateriali - Piattaforme di mercato",
						"MUSIC_AND_MOVIES": "Tempo libero - Musica e film",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Tempo libero, sport e hobby - Strumenti e attrezzature musicali",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Gioielli e accessori - Occhiali da sole e lenti non da vista",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elettronica - Prodotti per ufficio e relativi accessori",
						"OTHER_SERVICES": "Prodotti immateriali - Altri servizi",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Salute e bellezza - Cura personale e miglioramento del corpo",
						"PET_SUPPLIES": "Casa e giardino - Articoli per animali domestici",
						"PHARMACEUTICAL_PRODUCTS": "Salute e bellezza - Prodotti farmaceutici",
						"PLANTS_AND_FLOWERS": "Casa e giardino - Piante e fiori",
						"PRESCRIPTION_OPTICS": "Salute e bellezza - Ottica da prescrizione",
						"PRINTS_AND_PHOTOS": "Tempo libero, sport e hobby - Stampe e foto",
						"SAFETY_PRODUCTS": "Casa e giardino - Prodotti per la sicurezza",
						"SEX_TOYS": "Materiale erotico - Sex toys",
						"SPORTS_GEAR_AND_OUTDOOR": "Tempo libero, sport e hobby - Abbigliamento sportivo e outdoor",
						"TOBACCO": "Cibo e bevande - Tabacco",
						"TOOLS_AND_HOME_IMPROVEMENT": "Casa e giardino - Attrezzi e migliorie per la casa",
						"TRAVEL_SERVICES": "Prodotti immateriali - Servizi per i viaggi",
						"UNDERWEAR": "Abbigliamento e calzature - Intimo",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Tempo libero - Videogiochi e relativi accessori",
						"WHEELS_AND_TIRES": "Prodotti automobilistici - Ruote e pneumatici",
						"WINE_BEER_AND_LIQUOR": "Cibo e bevande - Vino, birra e liquori",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Abbigliamento e calzature - Calzature e abbigliamento giovanile"
					}
				},
				"currency": {
					"label": "Valuta"
				},
				"account_type": {
					"label": "Tipo di conto bancario",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Local Svezia",
						"LOCAL_US": "Local USA",
						"LOCAL_GENERIC": "Loca Norvegia/Danimarca",
						"SPECIAL": "Speciale",
						"BANKGIRO": "Local Svezia Bankgiro",
						"PLUSGIRO": "Local Svezia Plusgiro"
					}
				},
				"person_role": {
					"label": "Ruolo",
					"options": {
						"LEGAL_REPRESENTATIVE": "Rappresentante legale",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Beneficiario alternativo",
						"ULTIMATE_BENEFICIAL_OWNER": "Beneficiario assoluto",
						"OWNER": "Titolare"
					}
				},
				"business_size": {
					"label": "Dimensione attività",
					"options": {
						"LARGE": "grande",
						"MEDIUM": "media",
						"small": "piccola"
					}
				},
				"sensitive_good_category": {
					"label": "Fornisci uno qualsiasi dei seguenti articoli o servizi nel tuo negozio fisico?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Articoli con limiti di età",
						"LICENSED_WEAPONS": "Armi su licenza",
						"PHARMA_AND_MEDICAL_SERVICES": "Servizi medici e farmaceutici",
						"TRAVEL_TOURS_EVENTS": "Viaggi, tour ed eventi",
						"PEER_TO_PEER_MARKETPLACE": "Marketplace",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Sottoscrizioni, abbonamenti e servizi",
						"NONE": "Offro un tipo di articolo/servizio diverso"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabacco, sigarette elettroniche, vape, articoli a base di cannabis, alcool, contenuti per adulti",
						"LICENSED_WEAPONS": "Munizioni, coltelli da combattimento, attrezzatura da caccia, manganelli, spray al peperoncino",
						"PHARMA_AND_MEDICAL_SERVICES": "Distribuzione di farmaci con ricetta, procedure mediche incluse quelle estetiche e tatuaggi",
						"TRAVEL_TOURS_EVENTS": "Trasporti, eventi, piattaforme di biglietteria, hotel o alloggi, noleggi, agenzie turistiche",
						"PEER_TO_PEER_MARKETPLACE": "Servizi che consentono a terze parti di rivendere i propri articoli o di offrire servizi attraverso la propria piattaforma online",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Abbonamento su beni fisici, contenuti digitali, servizi di streaming, siti di incontri, ecc.",
						"NONE": "Offro un tipo di articolo/servizio diverso"
					},
					"error_message": "Siamo spiacenti. Non possiamo proseguire con la tua richiesta perché al momento non supportiamo il tipo di prodotto o servizio che hai selezionato."
				}
			},
			"common": {
				"country": {
					"label": "Paese"
				},
				"address": {
					"city": {
						"label": "Città"
					},
					"postal_code": {
						"label": "Codice postale"
					},
					"region": {
						"label": "Stato/regione"
					},
					"street_address": {
						"label": "Indirizzo negozio fisico"
					},
					"street_address2": {
						"label": "Indirizzo linea 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Nome azienda"
					},
					"registration_authority": {
						"label": "Autorità di registrazione"
					},
					"registration_id": {
						"label": "Numero di registrazione"
					},
					"subject_to_vat": {
						"label": "La tua attività ha una partita IVA?"
					},
					"vat_id": {
						"label": "Numero partita IVA"
					},
					"persons": {
						"date_of_birth": {
							"label": "Data di nascita"
						},
						"first_name": {
							"label": "Nome"
						},
						"last_name": {
							"label": "Cognome"
						},
						"person_identity_document": {
							"label": "Documento di identità"
						},
						"person_proof_of_address": {
							"label": "Prova di residenza"
						},
						"personal_identifier": {
							"label": "Identificazione personale"
						}
					},
					"should_auto_capture_orders": {
						"label": "Vuoi acquisire automaticamente gli ordini?",
						"tooltip": "Gli ordini devono essere acquisiti quando vengono consegnati in negozio o quando vengono spediti da un magazzino. Selezionando l’acquisizione automatica, l’ordine verrà acquisito automaticamente quando il cliente confermerà l’acquisto."
					}
				},
				"contract_entity": {
					"label": "Entità contrattuale"
				},
				"contract_onboarding_type": {
					"label": "Tipo di onboarding del partner commerciale"
				},
				"underwriting_inquiry_email": {
					"label": "Email di sottoscrizione"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Intestatario del conto"
					},
					"account_number": {
						"label": "Numero di conto"
					},
					"bic": {
						"label": "Codice BIC"
					},
					"iban": {
						"label": "Numero di conto (IBAN)"
					},
					"is_default": {
						"label": "Usa questo conto per valute non specificate"
					},
					"routing_number": {
						"label": "Coordinate bancarie"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Email di contatto"
					},
					"name": {
						"label": "Nome negozio"
					},
					"support_email": {
						"label": "Email Supporto clienti"
					},
					"support_phone": {
						"label": "Numero di telefono Supporto"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Vendita tradizionale di beni",
							"VOUCHER": "Buoni",
							"MEMBERSHIP": "Adesioni",
							"SUBSCRIPTION": "Iscrizione",
							"PHARMACIES": "Farmacie",
							"US_PHARMACIES": "Farmacie statunitensi",
							"MEDICAL_SERVICES": "Servizi medici",
							"MARKETPLACES": "Piattaforme di mercato",
							"FIREARM_DEALERS": "Rivenditori di armi da fuoco",
							"AUCTIONS": "Aste",
							"ALCOHOL": "Alcool",
							"TOBACCO": "Tabacco",
							"HEMP_CBD_THC": "Canapa, CBD o THC",
							"DONATIONS_CHARITY": "Donazioni e beneficenza",
							"TRAVEL": "Viaggi",
							"EVENTS": "Eventi",
							"COURSES": "Corsi",
							"EDUCATIONAL_COURSES": "Corsi di formazione",
							"FOOD_DELIVERY": "Consegna di cibo",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Pre-ordini personalizzati/mobili",
							"DIGITAL_CONTENT": "Contenuti digitali",
							"GAMING_INDUSTRY": "Industria del gioco d’azzardo (scommesse, casinò, lotteria)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "Termini e condizioni",
					"UPSELL_WEBSTORE_TO_KPOS": "Termini per Klarna In-store"
				},
				"pricing_terms": {
					"default": "Condizioni tariffarie",
					"UPSELL_WEBSTORE_TO_KPOS": "Condizioni tariffarie per Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Ulteriori informazioni",
				"bank_account": "Quali sono le tue coordinate bancarie?",
				"business_size": "Qual è il tuo volume annuale previsto attraverso il Point of Sale Klarna?",
				"in_store_get_started": "Avvia subito la tua attività con Klarna!",
				"in_store_legal_form": "Che tipo di attività svolgi?",
				"in_store_registered_address": "Qual è il tuo indirizzo registrato?",
				"in_store_registration": "La tua azienda è una società registrata?",
				"in_store_stakeholder": "Chi gestisce l’azienda?",
				"in_store_stores": "Quali sono i dati del tuo negozio per il Point of Sale Klarna?",
				"in_store_vat": "La tua attività ha una partita IVA?",
				"product_channel": "In che moto la tua attività pianifica di usare il Point of Sale Klarna?",
				"sensitive_goods": "Che categoria di prodotti venderai nel Point of Sale Klarna.",
				"ads_manager_get_started": "Ci siamo quasi",
				"content_store_get_started": "Ci siamo quasi."
			},
			"subtitle": {
				"additional_data": "Stiamo valutando la tua richiesta e abbiamo bisogno di alcune informazioni aggiuntive prima di procedere.",
				"bank_account": "Le transazioni Klarna saranno trasferite a questo conto bancario.",
				"business_size": "Abbiamo bisogno di alcune informazioni di base riguardo la tua attività per elaborare la tua richiesta.",
				"in_store_get_started": "Abbiamo bisogno di alcune informazioni di base per portarti nel posto giusto",
				"in_store_legal_form": "Siamo tenuti a fare alcune domande specifiche in base al tipo di attività.",
				"in_store_registered_address": "Questo è il luogo in cui la tua azienda è legalmente registrata e apparirà nelle fatture dei tuoi clienti Klarna.",
				"in_store_registration": "Abbiamo bisogno del numero di registrazione della tua azienda per verificare i dati dell’attività.",
				"in_store_stakeholder": "In qualità di istituto finanziario, abbiamo bisogno di conoscere queste informazioni",
				"in_store_stores": "Useremo le informazioni per impostare il tuo nuovo account Point of Sale Klarna.",
				"in_store_vat": "Se hai una partita IVA possiamo verificare più facilmente i dati della tua azienda.",
				"product_channel": "Scegli il canale di vendita primario. Potrai usare il Point of Sale Klarna per entrambi i canali.",
				"sensitive_goods": "L’onboarding self-service per il Punto Vendita Klarna non ti permette di vendere articoli che sono definiti da Klarna come riservati.",
				"ads_manager_get_started": "Inserisci un’email di fatturazione a cui verranno inviate le fatture delle campagne. Per attivare l’account devi essere un utente amministratore. L’amministratore può poi concedere i permessi agli altri utenti.",
				"content_store_get_started": "Prima di ottenere l’accesso a Content Manager, leggi e accetta i nostri termini e condizioni."
			},
			"summary": {
				"title": "Prima di inviare la tua richiesta controlla i tuoi dati"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Stiamo elaborando la tua richiesta. Potrebbe volerci un attimo.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Attendi…",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Attendi…"
					},
					"paragraphs": {
						"default": [
							{
								"text": "La tua richiesta è in fase di elaborazione e stiamo creando il tuo nuovo merchant ID."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Stiamo preparando tutto per il tuo account Ads Manager."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Stiamo preparando tutto per il tuo account Content Manager."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Congratulazioni! La tua richiesta è stata approvata.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Tutto pronto!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Tutto pronto!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "È il momento di integrare Klarna nel tuo negozio online. Inizia andando nella sezione “Prodotti” del Portale Merchant. Lì troverai le tue credenziali per l’integrazione e le istruzioni per il loro utilizzo."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Ora configuriamo il tuo negozio in modo che tu possa iniziare subito a ricevere i pagamenti."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Dirigiti su Ads Manager per iniziare a creare la tua prima campagna."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Dirigiti su Content Manager e pubblica oggi la tua prima offerta."
							}
						]
					},
					"second_title": {
						"default": "Visita la documentazione fornita da Klarna per ulteriori informazioni sull’integrazione",
						"UPSELL_WEBSTORE_TO_KPOS": "Hai bisogno di aiuto per configurare il negozio? Siamo qui per aiutarti",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Hai bisogno di aiuto ad usare Ads Manager? Dai un’occhiata alle nostre domande frequenti o contatta il nostro supporto commerciale, saremo felici di assisterti.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Hai bisogno di aiuto ad usare Content Manager? Dai un’occhiata alle nostre domande frequenti o contatta il nostro supporto commerciale, saremo felici di assisterti."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Le nostre linee guida ti aiuteranno a ottenere il massimo dalla nostra nuova partnership."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Contatta il nostro supporto commerciale, saremo lieti di assisterti."
							},
							{
								"text": "Contatta il supporto",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Mostra le domande frequenti",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Mostra le domande frequenti",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Iniziamo.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Iniziamo",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Iniziamo",
						"UPSELL_WEBSTORE_TO_KPOS": "Inizia a vendere"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Grazie. Stiamo valutando la tua richiesta.",
					"badge": "Circa 5-7 giorni",
					"paragraphs": [
						{
							"text": "Riceverai un’email al termine del processo di revisione o in caso di ulteriori informazioni necessarie."
						}
					],
					"second_title": "Nel frattempo controlla la tua casella di posta",
					"second_paragraphs": [
						{
							"text": "Ti abbiamo inviato un’email con oggetto “Ti diamo il benvenuto nel Portale Merchant di Klarna”. Segui i passaggi indicati per accedere e attivare il tuo account."
						}
					]
				},
				"SUSPENDED": {
					"title": "Purtroppo la tua domanda non è stata approvata.",
					"paragraphs": [
						{
							"text": "Dopo aver esaminato i dettagli della tua attività <strong>{businessName}</strong>, non possiamo procedere con l’elaborazione della tua richiesta."
						},
						{
							"text": "Questi sono alcuni dei motivi più frequenti:"
						},
						{
							"list": [
								{
									"text": "Il tuo negozio non rispetta le linee guida etiche di Klarna."
								},
								{
									"text": "Non è possibile mettersi in contatto con il tuo servizio clienti."
								},
								{
									"text": "Altri motivi di natura amministrativa."
								}
							]
						},
						{
							"text": "Grazie per il tuo interesse in <strong>Klarna [In-store]</strong>, ci auguriamo di poter collaborare in futuro."
						}
					],
					"second_title": "Se hai qualche domanda",
					"second_paragraphs": [
						{
							"text": "Contattaci per ulteriori informazioni riguardo la nostra decisione o qualsiasi altro prodotto Klarna, saremo felici di aiutarti."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Chi si occupa di firmare i contratti nella tua azienda?"
					},
					"subtitle": {
						"default": [
							{
								"text": "La tua azienda sta per stipulare un accordo con Klarna. Abbiamo bisogno di verificare chi sia legalmente autorizzato a firmare contratti."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Ci sono persone che possiedono più del 25% dell’azienda?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"default": [
							{
								"text": "Abbiamo bisogno di conoscere le persone che possiedono più del 25% delle azioni o dei diritti di voto dell’azienda o che esercitano un controllo simile. Siamo legalmente obbligati dalla direttiva UE contro il riciclaggio di denaro ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Chi gestisce l’azienda?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Siamo legalmente obbligati dalla direttiva antiriciclaggio dell’UE ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						],
						"US": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"CA": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Ci sono persone che possiedono più del 25% dell’azienda?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Come istituzione finanziaria siamo obbligati per legge a raccogliere queste informazioni."
							}
						],
						"default": [
							{
								"text": "Abbiamo bisogno di conoscere le persone che possiedono più del 25% delle azioni o dei diritti di voto dell’azienda o che esercitano un controllo simile. Siamo legalmente obbligati dalla direttiva UE contro il riciclaggio di denaro ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") a raccogliere queste informazioni."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Soluzioni",
					"title_2": "Metodi di pagamento",
					"note": "Tutti i prezzi sono per transazione.",
					"per_transaction": "per transazione",
					"cross_border_notice": "Potrebbero essere applicate ulteriori tariffe transfrontaliere",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "Guarda",
						"link_text": "appendice prezzi"
					},
					"not_available_for_business": "Non disponibile per la tua attività",
					"not_available_for_country": "Puoi vendere solamente in altri mercati",
					"not_compatible_with_platform": "Non disponibile per la tua piattaforma",
					"installed": "Installazione effettuata"
				},
				"buttons": {
					"next": "Prossimo"
				}
			}
		}
	}
};